{
  "accessDenied": {
    "description": "You don't have required permissions to view this page.",
    "title": "Access denied"
  },
  "accessory": {
    "type": "Accessory type"
  },
  "accessoryType": {
    "consumable": "Consumable",
    "kit": "Kit",
    "standalone": "Standalone"
  },
  "action": {
    "activate": "Activate",
    "add": "Add",
    "addNewTranslation": "Add new translation",
    "addToCollection": "Add to recipe book",
    "apply": "Apply",
    "approve": "Approve",
    "approveAll": "Approve all",
    "approveTranslations": "Approve translations",
    "blockConsumer": "Block consumer",
    "checkFaq": "Check FAQ",
    "checkManuals": "Check manuals",
    "clear": "Clear",
    "deactivate": "Deactivate",
    "deflag": "Deflag",
    "delete": "Delete",
    "downloadSubtitle": "Download subtitle",
    "edit": "Edit",
    "editUnpublishing": "Edit unpublishing",
    "export": "Export",
    "exportToCsv": "Export to CSV",
    "exportTranslations": "Export translations",
    "flagComment": "Report",
    "flagContent": "Flag {{ content }}",
    "generateAiTranslation": "AI generate translations",
    "hideLog": "Hide log",
    "like": "Like",
    "moveTo": "Move to",
    "moveToDraft": "Move to draft",
    "moveToLive": "Move to live",
    "pin": "Pin",
    "pinUnpin": "Pin/Unpin",
    "publish": "Publish",
    "publishContent": "Publish content",
    "publishUnpublish": "Publish/Unpublish",
    "quarantine": "Quarantine",
    "reactivate": "Reactivate",
    "reassign": "Reassign",
    "reject": "Reject",
    "rejectRequest": "Reject request",
    "remove": "Remove",
    "replace": "Replace",
    "report": "Report",
    "requestEdit": "Request edit",
    "requestEditAndTakeOffline": "Request edit and take offline",
    "requestReview": "Request review",
    "revokeReporting": "Revoke report",
    "saveAndApprove": "Save and approve",
    "saveDraft": "Save draft",
    "schedule": "Schedule",
    "scheduleOrPublish": "Schedule/publish",
    "search": "Search",
    "selectFile": "Select file",
    "showLog": "Show log",
    "takeOffline": "Take offline",
    "unapprove": "Unapprove",
    "unlike": "Unlike",
    "unschedule": "Unschedule",
    "updateBrands": "Update brands",
    "verify": "Verify"
  },
  "activityStatus": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "administrator": {
    "role": {
      "errors": {
        "required": "At least one user role is required"
      }
    }
  },
  "aiTranslationJobScope": {
    "all": "Regenerate all existing translations",
    "missingAndAI": "Regenerate only AI generated translations",
    "missingOnly": "Don’t regenerate existing translations"
  },
  "aiTranslationModal": {
    "description": "AI translation generation may take some time. Once the the AI finishes the translation process, translations will be created/updated.",
    "languagesDescription": "Select languages you want to translate to:",
    "regenerateDescription": "Do you want to regenerate existing translations for the languages you have selected?",
    "title": "AI translation generation"
  },
  "allergen": {
    "celery": "Celery",
    "cerealsContainingGluten": "Cereals containing gluten",
    "crustaceans": "Crustaceans",
    "eggs": "Eggs",
    "fish": "Fish",
    "lupin": "Lupin",
    "milk": "Milk",
    "molluscs": "Molluscs",
    "mustard": "Mustard",
    "noAllergens": "There are no allergens for this ingredient",
    "noUnofficialAllergens": "There are no other allergens for this recipes.",
    "nuts": "Nuts",
    "peanuts": "Peanuts",
    "placeholder": "Select allergens",
    "placeholderOther": "Select other allergens",
    "sectionTitle": "Food sensitivities and intolerances",
    "sesameSeeds": "Sesame Seeds",
    "soybeans": "Soybeans",
    "sulphurDioxideAndSulphites": "Sulphur dioxide and suplhites",
    "title": "Allergens",
    "titleOther": "Other allergens"
  },
  "announcement": {
    "browse": {
      "title": "Browse announcements"
    },
    "buttonText": "Button text",
    "code": "Code",
    "collectionID": "Recipe book ID",
    "collectionTitle": "Recipe book title",
    "content": "Content",
    "create": "Create announcement",
    "details": "Announcement details",
    "edit": "Edit announcement",
    "enterButtonText": "Enter button text",
    "enterCode": "Enter code",
    "enterDescription": "Enter announcement description",
    "enterLink": "Enter link",
    "enterTitle": "Enter announcement title",
    "errors": {
      "domain": {
        "required": "Domain is required"
      },
      "generic": {
        "description": "Error is displayed in the console. Please contact developers.",
        "title": "Error while saving the announcement"
      },
      "imageRequired": "Image is required",
      "language": {
        "required": "Language is required"
      },
      "user": {
        "required": "Profile is required"
      }
    },
    "hoverForPreview": "Hover for 9:16 preview",
    "imagePreview": {
      "fullScreen": {
        "message": "Mobile announcements full screen view (16:9) is generated automatically."
      },
      "homeScreen": {
        "message": "Mobile announcements home screen view (16:9) is generated automatically."
      }
    },
    "noResultsTitle": "No announcement found for  '{{ query }}'",
    "recipeID": "Recipe ID",
    "recipeTitle": "Recipe title",
    "replaceImage": {
      "description": "Do you want to replace current announcement image with image from this {{ contentType }}?",
      "imageResolutionWarning": "Warning: Image resolution is lower than {{ imageResolution }} px which is recommended to get a better quality of announcement image.",
      "title": "Replace announcement image"
    },
    "save": "Save",
    "saveTheAnnouncement": "Save the announcement?",
    "savedToastMessage": "Announcement saved",
    "searchUsers": "Search profiles",
    "title": "Announcement title",
    "translationErrors": {
      "buttonTextRequired": "Announcement button text is required",
      "descriptionRequired": "Announcement description is required",
      "titleRequired": "Announcement title is required"
    },
    "type": "Announcement type",
    "uploadImage": "Upload image",
    "userInfoMessage": "In order to find consumer’s profile, you must enter the consumer’s full email or phone number. If you want to link a Chef, you can find it by entering Chef’s name.",
    "view": "View announcement",
    "wantToSaveBeforeLeaving": "Do you want to save the changes before leaving?"
  },
  "announcementType": {
    "article": "Article",
    "collection": "Recipe book",
    "none": "General",
    "outgoing": "Link",
    "profile": "Profile",
    "recipe": "Recipe"
  },
  "approveTranslationsDialog": {
    "comment": {
      "placeholder": "Write a comment here."
    },
    "content": "You are about to approve all translations that are not approved for the language you select. Please enter your reason:"
  },
  "article": {
    "addContentToArticle": "Add {{ content }} to the article",
    "addedContentToArticle": "Added {{ content }} to the article ({{ currentValue }}/{{ maxValue }})",
    "applianceType": {
      "errorMessage": "Appliance type is required"
    },
    "articleType": {
      "errorMessage": "Article type is required",
      "label": "Article type",
      "placeholder": "Choose article type"
    },
    "closeDialog": {
      "description": "You are about to leave this screen and discard the article information you entered. Do you want to save the article to continue editing later?",
      "title": "Save the article?"
    },
    "contentNotValid": {
      "maxLinkedContentReached": {
        "dialogDescription": "You cannot add more {{ content }} to the article as you reached the maximum number of {{ content}} ({{currentNumber}} of {{maximumNumber}}).",
        "dialogTitle": "Maximum number reached"
      }
    },
    "create": "Create article",
    "description": {
      "errorMessage": "Article description is required",
      "label": "Description",
      "placeholder": "Enter article description"
    },
    "details": "Article details",
    "edit": "Edit article",
    "errors": {
      "generic": {
        "description": "Error is displayed in the console. Please contact developers.",
        "title": "Error while saving the article"
      },
      "imageRequired": "Image is required",
      "link": {
        "notValid": "URL is not valid."
      },
      "linkedContent": {
        "requiredNumber": "Number of {{ content }} must be between {{ minContentNumber }} and {{ maxContentNumber }}."
      },
      "missingTranslation": "Missing article step translation"
    },
    "id": "Article ID",
    "image": {
      "label": "Upload cover photo"
    },
    "link": {
      "placeholder": "Paste link here"
    },
    "linkedContentRemovalDescription": "After you remove this {{ content }}, it will not be visible in the search field until you save the article. Are you sure you want to remove the {{ content }}?",
    "linkedContentRemovalTitle": "Remove from the article",
    "maintenanceFrequency": {
      "label": "Maintenance frequency"
    },
    "maintenanceProperty": {
      "label": "Maintenance property"
    },
    "missingDialogOptions": {
      "question": "Do you want to edit the article now?"
    },
    "noContentFound": "No {{ content }} found for",
    "noLinkedContentAddedToArticle": "There are no {{ linkedContent }} added to this article.",
    "noProcessingSteps": "Article doesn't have any steps.",
    "placeholder": {
      "noRecipes": "Article does not have any recipes"
    },
    "recipeNotValid": {
      "translationNotApproved": {
        "title": "Recipe is not valid for the article"
      },
      "wrongAuthorType": {
        "description": "Recipe author must be Philips"
      }
    },
    "searchAddedContent": "Search added {{ content }}",
    "searchContent": "Search {{ content }}",
    "selectLanguageApplianceFirst": "Please choose language and appliance type first.",
    "step": {
      "delete": {
        "content": "Are you sure you want to delete the step?",
        "title": "Delete step"
      }
    },
    "steps": {
      "title": "Add steps"
    },
    "title": {
      "errorMessage": "Article title is required",
      "placeholder": "Enter article title"
    },
    "toastMessage": {
      "saved": "Article saved",
      "translationSaved": "Article translation saved successfully"
    },
    "preview": {
      "applianceDetailsPage": "Appliance details page",
      "searchPage": "Search page"
    }
  },
  "articlePublicationModal": {
    "missingArticleLiveTranslationsForCountry": "One or more linked articles are missing translations.",
    "missingPublishedArticles": "{{ publishedArticles }}/{{ totalArticles }} articles linked to the article have been published in the country profile. Unpublished articles will not be visible within the article."
  },
  "authorType": {
    "consumer": {
      "label": "User generated",
      "shortLabel": "C"
    },
    "homeIdTeam": {
      "label": "HomeID Team managed",
      "shortLabel": "H"
    }
  },
  "breakdownTable": {
    "breakdown": "Breakdown",
    "per100g": "per 100 g",
    "per100ml": "Per 100 ml",
    "percentDailyValue": "% NRV*",
    "percentDailyValuePer100g": "% NRV per 100 g *",
    "percentDailyValuePer100ml": "% NRV per 100 ml *",
    "percentDailyValuePerServing": "% NRV per serving *"
  },
  "bulkActions": {
    "contentList": {
      "contentMustBeApprovedForMoveToLive": "Some of the content must be in Approved status to enable the Move to live action",
      "contentMustBeLiveOrApprovedToAIGenerateTranslations": "All content must be in Approved, Live, or Live flagged status to AI generate translations",
      "contentMustBeLiveToApproveTranslations": "All content must be in Live or Live flagged status to approve translations",
      "contentMustBeLiveToExportTranslations": "All content must be in Live or Live flagged status to export translations",
      "contentMustBeLiveToPublish": "All content must be in Live or Live flagged status to publish",
      "contentTypeEmptyState": {
        "description": "There are no results for this content type.",
        "title": "No content found"
      },
      "description": "Select a content list and choose an action below in the footer bar menu.",
      "discardEdit": {
        "content": "Are you sure you want to leave the edit form and discard the changes you made? "
      },
      "emptyListLabel": "Empty list",
      "header": {
        "actions": "Actions",
        "content": "Content"
      },
      "notSelectedEmptyState": {
        "description": "Select a list from the content list to preview the content.",
        "title": "No content list"
      },
      "saved": "Content list is saved",
      "selectedStatusEmptyState": {
        "description": "There are no results for this status type.",
        "title": "No content found"
      }
    },
    "contentListPublishedToastMessage": "Content list published successfully",
    "contentLists": {
      "shortIdsPlaceholder": "Paste the IDs here."
    },
    "contentPreview": "Content preview ({{ contentCount }})",
    "moveToLive": {
      "allMoved": "All content moved to Live",
      "confirmationText": "Are you sure you wish to move {{ count }} item(s) to live?",
      "errorList": "Could not move the following items to live: <br /> {{ items }}",
      "errorTitle": "Error when moving items to live",
      "someMoved": "{{ moved }} of {{ total }} item(s) successfully moved to live."
    },
    "publishContentDialog": {
      "onlyDefaultCountryProfilesSupported": "Only the default country profiles are supported when Highlights are present in the list for publishing."
    },
    "publishingResults": {
      "description": "Bulk publishing could not be performed because of problems related to some content. Please correct the issues listed below and try again.",
      "title": "Bulk publishing failed"
    },
    "translationsApprovedToastMessage": "Translations approved successfully"
  },
  "bulkExportTranslationModal": {
    "onlyAiGenerated": {
      "label": "Which translations to include?"
    },
    "title": "Export content translations",
    "useDefaultTranslation": {
      "label": "Which translations do you want to export?"
    }
  },
  "button": {
    "add": "Add",
    "back": "Back",
    "cancel": "Cancel",
    "close": "Close",
    "collapse": "Collapse",
    "confirm": "Confirm",
    "deflag": "Deflag",
    "delete": "Delete",
    "discard": "Discard",
    "edit": "Edit",
    "generateTranslations": "Generate translations",
    "hide": "Hide {{ label }}",
    "leave": "Leave",
    "no": "No",
    "ok": "OK",
    "post": "Post",
    "preview": "Preview",
    "previewVideo": "Preview video",
    "resolve": "Resolve",
    "save": "Save",
    "saveChanges": "Save changes",
    "search": {
      "clear": "Clear search",
      "search": "Search"
    },
    "show": "Show {{ label }}",
    "stay": "Stay",
    "unresolve": "Unresolve",
    "yes": "Yes",
    "yesChange": "Yes, change",
    "yesDelete": "Yes, delete"
  },
  "calendar": {
    "view": {
      "day": "Day",
      "month": "Month",
      "week": "Week"
    }
  },
  "calendarEvent": {
    "publishing": "Publishing",
    "unpublishing": "Unpublishing"
  },
  "category": {
    "placeholder": "Choose {{categoryName}}"
  },
  "changelog": {
    "header": {
      "subtitle": "Lists of changes for each release of HomeID Administrative portal",
      "title": "Release notes"
    },
    "notes": {
      "hide": "Hide notes",
      "show": "Show notes"
    },
    "subtitle": {
      "defects": "Bug fixes",
      "maintenanceStories": "Maintenance",
      "notes": "Notes",
      "userStories": "Features"
    }
  },
  "collection": {
    "addBasicInformation": "Add basic information",
    "addRecipe": "Add",
    "addRecipesToCollection": "Add recipes to the recipe book",
    "addedRecipesToCollection": "Added recipes to the recipe book  ({{ currentValue }})",
    "articleNotValid": {
      "defaultError": {
        "description": "The article and the collection do not match."
      },
      "missingArticleSteps": {
        "description": "Article {{ articleTitle }} has no steps, which is temporarily required to avoid an issue on the Android version of the application."
      },
      "noMatchingDomains": {
        "description": "Article {{ articleTitle }} and the collection do not have any matching domains. The article must be global or have the same domain as the collection."
      },
      "translationNotApproved": {
        "description": "Article {{ articleTitle }} and the collection do not have any approved translations in common.",
        "title": "Article is not valid for the collection"
      },
      "wrongContentCategory": {
        "description": "Article {{ articleTitle }} and the collection do not share the required appliance categories."
      },
      "wrongContentStatus": {
        "description": "The article {{ articleTitle }} is not in live status."
      }
    },
    "articleResetInfoMessage": "Content will be reset upon changing appliance, type, device, or accessory.",
    "changeStatus": {
      "approval": {
        "content": "You are about to approve this recipe book. Please enter your approval reason:",
        "title": "Recipe book approval"
      },
      "deflag": {
        "content": "You are about to deflag this recipe book and move it back to Live. Please enter your reason:",
        "title": "Deflagging recipe book"
      },
      "deletion": {
        "content": "Are you sure you want to delete a recipe book?",
        "title": "Recipe book deletion"
      },
      "generic": {
        "content": "You are about to change the recipe book status. Please enter your reason:",
        "title": "Changing recipe book status"
      },
      "inReview": {
        "content": "You are about to move recipe book in review. Please enter your reason:",
        "title": "Move to in review"
      },
      "moveToDraft": {
        "content": "You are about to move this recipe book to draft. Please enter your reason:",
        "title": "Recipe book draft"
      },
      "moveToLive": {
        "content": "You are about to move this recipe book to live. Please enter your reason:",
        "title": "Moving the recipe book to Live"
      },
      "rejectRequest": {
        "content": "You are about to reject this request. Please enter your rejection reason:",
        "title": "Reject approving request"
      },
      "takeOffline": {
        "content": "You are about to unpublish the recipe book from all of the country profiles. Please enter your reason:",
        "title": "Taking the recipe book offline"
      }
    },
    "create": "Create {{device}} recipe book",
    "createUniversal": "Create recipe book",
    "description": "Description",
    "details": "Recipe book details",
    "edit": "Edit {{device}} recipe book",
    "editRecipeBook": "Edit recipe book",
    "editRecipeList": {
      "label": "Edit recipe list"
    },
    "enterDescription": "Enter recipe book description",
    "enterTitle": "Enter recipe book title",
    "hoverForPreview": "Hover for 3:4 preview",
    "id": "Recipe book ID",
    "imageUploadPreview": {
      "oneByOneRatioMessage": "Recipe book cover view (1:1) on Favorites screen is generated automatically",
      "threeByFourRatioMessage": "Recipe book cover view (3:4) on Home screen is generated automatically"
    },
    "incompatibleRecipes": {
      "proceedLabel": "Remove them from the recipe book",
      "removed": "Recipes successfully removed from the recipe book.",
      "title": "The following recipes in the recipe book are not compatible with the recipe book."
    },
    "missingDialogOptions": {
      "question": "Do you want to edit the recipe book now?"
    },
    "noArticlesFound": "No articles found",
    "noRecipesAddedToCollection": "There are no recipes added to this recipe book.",
    "noRecipesFound": "No recipes found",
    "noVideosFound": "No videos found",
    "notFound": "Recipe book not found",
    "placeholder": {
      "noArticles": "Article collection does not have any articles",
      "noRecipes": "Recipe book does not have any recipes",
      "selectApplianceAndProductFirst": "Select appliance and at least one device or accessory first.",
      "selectApplianceAndTypeFirst": "Select appliance and type first."
    },
    "productChangeInfoMessage": "Content will be reset upon changing appliance, device, or accessory.",
    "reassignLanguage": {
      "description": "Choose a supported language of the recipe book's country.",
      "toastMessage": "Recipe book language was changed to {{ language }}"
    },
    "recipeNotValid": {
      "defaultError": {
        "description": "The recipe and the recipe book do not match."
      },
      "noMatchingDomains": {
        "description": "Recipe {{recipeTitle}} and the recipe book do not have any matching domains. The recipe must be global or have the same domain as the recipe book."
      },
      "translationNotApproved": {
        "description": "Recipe {{recipeTitle}} and the recipe book do not have any approved translations in common.",
        "title": "Recipe is not valid for the recipe book"
      },
      "wrongContentStatus": {
        "description": "Recipe {{recipeTitle}} and the recipe book do not have matching appliances."
      }
    },
    "recipeRemovalDescription": "Are you sure you want to remove the recipe from the recipe book?",
    "recipeRemovalTitle": "Remove from recipe book",
    "recipeSearchDisabledMessage": "Select domain, language and appliance first",
    "recipeWarning": {
      "missingTranslations": "Recipe does not have approved translations for: {{ languages }}",
      "notPublished": "Recipe is not published to: {{ countryProfiles }}"
    },
    "save": "Save",
    "saveTheCollection": "Save the recipe book?",
    "searchAddedArticles": "Search added articles",
    "searchAddedRecipes": "Search added recipes",
    "searchArticles": "Search articles",
    "searchRecipes": "Search recipes",
    "status": {
      "toast": "Recipe book status has been successfully changed to \"{{ status}}\""
    },
    "title": "Recipe book title",
    "toastMessage": {
      "saved": "Recipe book saved",
      "trasnlationSaved": "Recipe book translation saved successfully."
    },
    "translationErrors": {
      "descriptionRequired": "Recipe book description is required.",
      "titleRequired": "Recipe book title is required."
    },
    "validators": {
      "recipesRequired": "Recipe book must have at least one recipe."
    },
    "wantToSaveBeforeLeaving": "You are about to leave this screen and discard the recipe book information you entered. Do you want to save the recipe book to continue editing later?"
  },
  "collectionBundle": {
    "contentCategory": {
      "choose": "Choose appliance"
    },
    "searchCollections": "Search recipe books ",
    "selectApplianceFirst": "Select appliance first"
  },
  "collectionPack": {
    "activation": {
      "contentWillBeDeactivated": "<div>You are activating recipe book pack for {{ country }}, therefore, {{ collectionBundlesForDeactivation }} will be deactivated.</div>",
      "missingRecipeBooksPerDeviceCategory": "At least {{ minRecipeBooks }} recipe books per appliance must be published to the country."
    },
    "addBasicInformation": "Add basic information",
    "addCollectionsToPack": "Add recipe books to the pack (min.{{ minCollections }})",
    "addedCollectionsToPack": "Added recipe books to the pack ({{ currentValue }})",
    "collectionMustBeLiveModal": {
      "description": "Recipe book \"{{ collectionTitle }}\" is not LIVE. Remove it from the pack or move it to LIVE before saving this pack.",
      "title": "All recipe books must be in LIVE status"
    },
    "collectionRemovalDescription": "Are you sure you want to remove the recipe book from the pack?",
    "collectionRemovalTitle": "Remove from pack",
    "collections": {
      "emptyStateMessage": "There are no recipe books in this pack."
    },
    "details": "Recipe book pack details",
    "enterTitle": "Enter title",
    "noCollectionsAddedToCollectionPack": "There are no recipe books added to this pack.",
    "noCollectionsFound": "No recipe books found for ",
    "saveTheCollectionPack": "Do you want to save the changes before leaving?",
    "searchAddedCollections": "Search added recipe books",
    "title": "Recipe book pack title",
    "toastMessage": {
      "saved": "Recipe book pack saved"
    },
    "validation": {
      "notEnoughCollectionsForCountry": "At least {{ numberOfCollections }} recipe books from the recipe book pack must be published to the country."
    },
    "wantToSaveBeforeLeaving": "You are about to leave this screen and discard the recipe book pack information you entered. Do you want to save the recipe book pack to continue editing later?"
  },
  "collectionPublicationModal": {
    "missingRecipesPerDeviceCategory": "Recipe book does not contain at least {{ minRecipes }} recipes per appliance which are live and published in this country.",
    "noArticlesLabel": "No articles from the collection have been published in this country.",
    "noRecipesLabel": "No recipes from the recipe book have been published in this country."
  },
  "collections": {
    "notFound": "No recipe books found"
  },
  "comment": {
    "browse": {
      "all": "Browse comments"
    },
    "commentFrom": "Comment from {{ user }}",
    "consumerComments": "Consumer comments",
    "deflagging": "Deflagging comment",
    "deflaggingReasons": "You are about to deflag this comment. Please enter your reason:",
    "deleteModal": {
      "description": "Are you sure you want to delete this comment?",
      "title": "Deleting comment"
    },
    "details": "Comment details",
    "editComment": "Edit comment",
    "flag": {
      "content": "You are about to report this consumer’s comment. Please select your reporting reason:",
      "subtitle": "Flagging reason",
      "title": "Report {{ user }}'s comment"
    },
    "inContent": "In {{ content }}",
    "inRecipe": "In recipe",
    "plural": "comments",
    "postComment": "Post comment",
    "postNewComment": "Post new comment",
    "reactionModal": {
      "description": {
        "like": "By liking, the user will be notified that HomeID liked their comment. Are you sure you want to proceed?",
        "unlike": "Are you sure you want to unlike this comment?"
      },
      "title": {
        "like": "Like comment",
        "unlike": "Unlike comment"
      }
    },
    "resolved": "Resolved",
    "singular": "comment",
    "toastMessage": {
      "deflag": "Comment was successfully deflaged",
      "delete": "Comment was successfully deleted"
    },
    "viewContent": "View {{ content }}",
    "viewRecipe": "View recipe",
    "replies": "Replies",
    "reply": "Reply",
    "threadReplies": {
      "noReplies": "There are no replies to this comment."
    }
  },
  "commentLevel": {
    "reply": "Reply",
    "rootComment": "Root comment"
  },
  "commentLevelIndicator": {
    "comment": {
      "label": "View comment"
    },
    "reply": {
      "label": "View reply"
    }
  },
  "commentState": {
    "resolved": "Resolved",
    "unresolved": "Unresolved"
  },
  "comments": {
    "commentsByConsumers": "Comments by consumers",
    "noComments": "No comments",
    "statusIndicatorLabel": "Unresolved comments"
  },
  "common": {
    "AllTranslations": "All translations",
    "accessories": "Accessories",
    "accessoriesInKit": "Accessories in kit",
    "accessory": "Accessory",
    "accessoryKits": "Accessory kit",
    "add": "Add",
    "addArticles": "Add articles",
    "addContent": "Add content",
    "addExternalLink": "Add external link",
    "addFallbackLanguage": "Add fallback language",
    "addItem": "Add {{ item }}",
    "addRecipes": "Add recipes",
    "addTags": "Add tags",
    "addedArticles": "Added articles ({{ items }})",
    "addedRecipes": "Added recipes ({{ items }})",
    "additionalProperties": "Additional properties",
    "aiTranslationsPending": "AI translation generation is in progress for the following languages: {{ languages }}",
    "all": "All",
    "amount": "Amount",
    "and": "and",
    "announcement": {
      "plural": "Announcements"
    },
    "any": "Any",
    "appliance": {
      "choose": "Choose appliance(s)",
      "plural": "Appliances",
      "singular": "Appliance"
    },
    "article": {
      "plural": "Articles"
    },
    "articleCollection": {
      "plural": "Article collections"
    },
    "articleList": "Article list",
    "articleRemovalConfirmation": "Are you sure you want to remove the article?",
    "articleStepTranslationRequirement": "Each step is required to have either a title or a description",
    "assets": "Device assets",
    "assign": "Assign",
    "assignToDevice": "Assign to product",
    "atLeastOneItemIsRequired": "At least one {{ item }} must be added.",
    "author": {
      "singular": "Author"
    },
    "availableIn": "Available in",
    "availableInformation": "Available information",
    "background": "Background",
    "basicSetup": "Basic setup",
    "brand": {
      "singular": "Brand"
    },
    "browse": {
      "aiTranslationsList": "Browse AI translation tasks",
      "articleCollections": "Browse article collections",
      "articles": "Browse articles",
      "campaigns": "Browse campaigns",
      "collections": "Browse recipe books",
      "consumerDeletionRequests": "Consumer deletion requests",
      "consumerList": "Consumer list",
      "countdowns": "Browse countdowns",
      "countries": "Browse countries",
      "customTables": "Browse custom tables",
      "easyRecipeBook": "Browse easy recipe books",
      "homescreenCarousels": "Home Screen carousels",
      "ingredients": "Browse ingredients",
      "languageSelect": {
        "ingredients": "Display ingredients in language"
      },
      "noResultsPlacehholder": {
        "subtitle": "There are no results for this search. Please try another search.",
        "subtitleDefault": "There are currently no results.",
        "title": "No results found for '#s'",
        "titleDefault": "No results"
      },
      "noResultsPlacehholderInject": {
        "subtitleDefault": "There are currently no {{ contentType }}.",
        "subtitleDefaultSingular": "There is currently no {{ contentType }}.",
        "titleEmpty": "No {{ contentType }}"
      },
      "noResultsPlaceholderInject": {
        "title": "No {{ contentType }} found for {{ query }}"
      },
      "packs": "Browse packs",
      "plans": "Browse message plans",
      "productRanges": "Browse product ranges",
      "productRecipeLists": "Browse product recipe lists",
      "products": "Browse products",
      "promoCodes": "Browse promo codes",
      "recipeBookCarousels": "Browse recipe book carousels",
      "recipeCarousels": "Browse recipe carousels",
      "recipes": "Browse recipes",
      "reportedContent": "Reported content",
      "shopAnnouncements": "Browse shop announcements",
      "surveys": "Browse polls",
      "unassignedProducts": "Browse unassigned products"
    },
    "bulkActions": {
      "aiTranslationsPending": "AI generation of translations for the Starter pack is in progress.",
      "subtitle": "Content translations and management.",
      "title": "Translations and content actions"
    },
    "by": "By",
    "campaign": {
      "plural": "Campaigns"
    },
    "campaignFrequency": "Campaign frequency",
    "cancel": "Cancel",
    "changesDetected": "Changes detected",
    "checkContentForMoreDetails": "Please check content for more details",
    "choose": {
      "country": "Choose country",
      "domain": "Choose domain",
      "language": "Choose language",
      "variant": "Choose variant",
      "variants": "Choose variants"
    },
    "chooseContentType": "Choose content type",
    "chooseItem": "Choose {{ item }}",
    "codename": "Codename",
    "collection": {
      "plural": "recipe books"
    },
    "collectionPack": {
      "plural": "recipe book packs",
      "singular": "Recipe book pack"
    },
    "collectionType": {
      "manual": "Manual"
    },
    "comment": {
      "plural": "Comments",
      "singular": "Comment"
    },
    "commentBy": "Comment by",
    "conjunction": {
      "and": " and ",
      "or": " or "
    },
    "connected": "Connected",
    "consumer": {
      "plural": "Consumers",
      "singular": "Consumer"
    },
    "consumerDetails": "Consumer details",
    "consumerImage": {
      "singular": "Consumer image"
    },
    "consumersReported": "Consumers reported",
    "contactEmail": "Contact email address",
    "contactEmailPlaceholder": "Enter contact email",
    "content": "Content",
    "contentInfo": "Content info",
    "contentManagement": "Content management",
    "contentSourceTranslation": "Content source translation",
    "continue": "Continue",
    "continueEditing": "Continue editing",
    "conversion": "Conversion",
    "copied": "Copied!",
    "copiedToClipboard": "Copied to clipboard",
    "copy": "Copy",
    "copyAllShortIds": "Copy all short IDs",
    "copyTranslationsQuestion": "Copy translations?",
    "countdown": {
      "plural": "Countdowns"
    },
    "country": {
      "plural": "Countries",
      "singular": "Country"
    },
    "countryLanguageCombinations": {
      "label": "Country/Language combinations",
      "missingFaqs": "Country/Language combinations with missing FAQs",
      "missingManuals": "Country/Language combinations with missing manuals",
      "missingTroubleshootingArticles": "Country/Language combinations with missing troubleshooting articles",
      "tooltip": "Number of country/language combinations where device is available"
    },
    "createItem": "Create {{ item }}",
    "createdBy": "Created by",
    "createdByWithDate": "User name and date added",
    "ctn": "CTN",
    "ctv": "CTV",
    "dateAndTime": "Date & Time",
    "degreeCelsius": "°C",
    "degreeFahrenheit": "°F",
    "delete": "Delete",
    "description": "Description",
    "deselectAll": "Deselect all",
    "deselectFromAllPages": "Deselect from all pages",
    "device": {
      "fetchAssets": "Fetch device assets",
      "fetchAssetsDescription": "Fetching may take a few minutes.",
      "plural": "Devices",
      "singular": "Device"
    },
    "deviceActivation": "Device activation",
    "deviceDeactivation": "Device deactivation",
    "deviceGroup": "Device group",
    "deviceImage": "Device image",
    "dialog": {
      "areYouSure": "Are you sure?",
      "discardChanges": "Discard changes",
      "discardMessage": "You have unsaved changes. Do you want to leave this page?",
      "discardTitle": "Unsaved data will be lost"
    },
    "disabled": "Disabled",
    "domain": {
      "plural": "Domains",
      "singular": "domain"
    },
    "duplicateProductVariants": "Multiple product variants with the same CTN & CTV combination were detected. CTN & CTV combination must be unique.",
    "duplicateTranslationLanguages": "Multiple translations with the same language were detected. There can be only one translation per language.",
    "eCommerceItem": {
      "addItems": "Add e-commerce items",
      "duplicateECommerceItems": "Multiple e-commerce items with the same e-commerce model were detected. E-commerce model must be unique within the product type.",
      "empty": "No e-commerce items added.",
      "singular": "E-commerce item"
    },
    "eCommerceOnlyAccessories": "E-commerce only accessories",
    "eCommerceOnlyDevices": "E-commerce only devices",
    "easyRecipeBook": {
      "plural": "Easy recipe books",
      "singular": "Easy recipe book"
    },
    "ecommerceModel": "E-commerce model",
    "edit": "Edit",
    "editItem": "Edit {{ item }}",
    "email": "Email",
    "emailLabel": {
      "placeholder": "Enter email"
    },
    "enabled": "Enabled",
    "enter": {
      "item": "Enter {{ item }}"
    },
    "enterItemTitle": "Enter {{ item }} title",
    "error": {
      "country": {
        "required": "Country is required"
      },
      "invalidInput": "Invalid input",
      "pastDate": "Date must be in the future.",
      "startDateBeforeEnd": "End date must be after start date.",
      "wholeNumber": "Only whole numbers are allowed."
    },
    "errors": {
      "checkConnection": "Please check the connection or the file you’re uploading.",
      "somethingWentWrong": "Something went wrong",
      "unknownError": "Unknown error"
    },
    "event": {
      "singular": "event"
    },
    "export": {
      "deviceAssetCoverage": "CSV list of device asset coverage",
      "missingActivatedProducts": "CSV list of devices not activated on home.id platform",
      "missingFaqArticles": "CSV list of missing FAQ articles on home.id platform",
      "missingTroubleshootingArticles": "CSV list of missing troubleshooting articles on home.id platform",
      "missingUserManuals": "CSV list of missing user manuals"
    },
    "externalLink": "External link",
    "fallbackLanguage": "Fallback language",
    "faqArticles": {
      "label": "FAQ articles",
      "tooltip": "Number of country/language combinations with at least one FAQ article (not total FAQ articles)"
    },
    "file": "File",
    "filterOutdated": "Saved search contains a filter that is not available anymore. The removed filter will be ignored.",
    "filterSetup": "Filter setups",
    "filters": "Filters",
    "filtersApplied": {
      "plural": "Filters applied",
      "singular": "Filter applied"
    },
    "findByText": "Find {{ item }} by text",
    "firstTimeReported": "First time reported",
    "general": "General",
    "genericError": {
      "description": "Error is displayed in the console. Please contact developers.",
      "title": "An error occurred"
    },
    "getingStartedButton": "Getting started",
    "hide": "Hide",
    "hideParameters": "Hide parameters",
    "high": "High",
    "highlight": {
      "plural": "Highlights"
    },
    "history": "history",
    "homeIdTeam": "HomeID Team",
    "hourAbbreviation": "h",
    "icon": "Icon",
    "image": "Image",
    "imageSizeValidationMessage": "You can upload only PNG or JPG images larger than {{ minWidth }}×{{ minHeight }}px.",
    "imageType": "Image type",
    "inactive": "Inactive",
    "includedInKits": "Included in kits",
    "incompatibleDevices": "Incompatible devices",
    "ingredient": {
      "plural": "ingredients"
    },
    "insert": "Insert",
    "invalidTranslation": "The translation is not valid.",
    "invalidVTTfile": "Selected file contains errors and is not a valid WebVTT file.",
    "itemDetails": "{{ item }} details",
    "itemId": "{{ item }} ID",
    "itemTitle": "{{ item }} title",
    "items": "Items",
    "language": {
      "addNew": "Add new language",
      "plural": "Languages",
      "singular": "Language"
    },
    "languageCode": "Language code: {{ code }}",
    "languageOfOrigin": "Language of origin",
    "lastTimeReported": "Last time reported",
    "link": "Link",
    "locale": "Locale",
    "localizedVideo": {
      "addItems": "Add DAM videos",
      "empty": "No DAM videos added."
    },
    "locked": "Locked",
    "low": "Low",
    "minuteAbbreviation": "min",
    "mobilePreview": "Mobile design preview",
    "more": "more",
    "multipleItems": "Multiple items",
    "name": "Name",
    "navigateToPreviousPage": "Close and navigate to previous page",
    "no": "No",
    "noAccessories": "No accessories found",
    "noAddedArticles": "No added articles",
    "noAddedRecipes": "There are no added recipes.",
    "noCountryProfiles": "Country has no profiles.",
    "noDevices": "No devices found",
    "noIngredients": "There are no selected ingredients.",
    "noItems": "There are no items",
    "noItemsFound": "No items found",
    "noLinks": "There are no links for this language",
    "noResult": {
      "criteria": {
        "plural": "There are no {{ item }} matching this criteria."
      },
      "plural": "There are no {{ item }}",
      "singular": "There is no {{ item }}"
    },
    "noSavedSearches": "No saved searches",
    "noTranslations": "There are no translations.",
    "nonConnected": "Non-connected",
    "nonPremium": "Non premium",
    "none": "None",
    "notPublished": "Not published",
    "note": "Note",
    "numberOf": {
      "comments": "comments",
      "favorites": "favorites",
      "recipeBooks": "Number of recipe books",
      "recipes": "recipes",
      "views": "views"
    },
    "nutritionalClaim": {
      "plural": "Nutritional claims"
    },
    "nutriuExternalLink": "HomeID external link",
    "onboardingAnnouncement": {
      "plural": "Onboarding announcements"
    },
    "onlyAiGeneratedTranslations": "Only AI-generated translations",
    "order": "Order",
    "other": "Other",
    "outdated": "Outdated",
    "palVideoLink": "PAL Video link",
    "percentage": "%",
    "philipsUser": "Philips user",
    "pinnedCollection": {
      "plural": "pinned recipe books",
      "singular": "Pinned recipe book"
    },
    "premium": "Premium",
    "premiumContent": "Premium content",
    "preselected": "Preselected",
    "preselectedAccessories": "Preselected accessories",
    "pressure": "Pressure",
    "priority": "Priority",
    "product": {
      "noAssets": "Device is not activated in any country. Activate device to see its assets.",
      "noEcommerceModel": "Device is missing E-commerce model property. Assets cannot be accessed without that information.",
      "plural": "Product models",
      "singular": "Product model"
    },
    "productActivatedToast": "The product is successfully activated.",
    "productActivationDescription": "The product can only be activated in countries that support the product appliance and have product brand defined for the device. After the activation, the product will be visible in the mobile app.",
    "productDeactivatedToast": "The product has been successfully deactivated.",
    "productDeactivationConfirmation": "By deactivating all of the product variants, the product will no longer be visible to mobile users on the device selection in this country. Are you sure you want to continue?",
    "productDeactivationDescription": "If all variants of a product are deactivated from a country, the product will not be visible in the mobile app.",
    "productFaq": "Product FAQ",
    "productManualUrl": "Product manual url",
    "productManuals": "Product manuals",
    "productRange": "Product range",
    "productRecipeList": {
      "plural": "Product recipe lists"
    },
    "productTroubleshootingArticles": "Product troubleshooting articles",
    "products": "Products",
    "promoCode": {
      "plural": "Promo codes",
      "singular": "Promo code"
    },
    "pushMessage": {
      "plural": "Push notifications",
      "singular": "Push notification"
    },
    "questions": "Questions",
    "reaction": {
      "hasManagedLike": "Liked by HomeID",
      "numberOfLikes": "No. of likes"
    },
    "readMore": "Read more",
    "recipe": {
      "byConsumer": "By Consumer",
      "byHomeIdTeam": "By HomeID Team",
      "byPhilips": "By Philips",
      "plural": "recipes"
    },
    "recipeBook": {
      "plural": "Recipe books",
      "singular": "Recipe book"
    },
    "recipeBookCarousel": {
      "plural": "Recipe book carousels",
      "singular": "Recipe book carousel"
    },
    "recipeBookIsRequired": "Recipe book is required.",
    "recipeBooksAreRequired": "At least one recipe book must be added.",
    "recipeCarousel": {
      "plural": "Recipe carousels",
      "singular": "Recipe carousel"
    },
    "recipeList": {
      "singular": "Recipe list"
    },
    "recipeRemovalConfirmation": "Are you sure you want to remove the recipe?",
    "recipeType": "Recipe type",
    "recipesRequired": "At least one recipe must be added.",
    "referenceQuantityAndUnit": "Per {{quantity}} {{unit}}",
    "remove": "Remove",
    "removeArticles": "Remove articles",
    "removeRecipes": "Remove recipes",
    "replaceImage": {
      "description": "Do you want to replace the current image with an image from this {{ contentType }}?",
      "title": "Replace image"
    },
    "report": {
      "plural": "reports"
    },
    "reportedContent": {
      "plural": "reported content"
    },
    "reporterCountriesNo": "No. of reporter countries",
    "reporterLanguagesNo": "No. of reporter languages",
    "resetForm": "Reset form",
    "results": {
      "plural": "Results",
      "singular": "Result"
    },
    "role": {
      "add": "Add new role",
      "select": "Select role",
      "singular": "Role"
    },
    "save": "Save",
    "saveChangesBeforeLeaving": "Do you want to save the changes before leaving?",
    "saveSearch": "Save search",
    "saveSuccessToastMessage": "Your changes have been successfully saved.",
    "savedSearches": "Saved searches",
    "scheduleContent": "Schedule content",
    "scheduledBy": "Scheduled by",
    "scope": "Scope",
    "searchAddedItems": "Search added {{ items }} ({{ numberOfItems }})",
    "searchAddedItemsPlaceholder": "Search added {{ items }}",
    "searchAiTranslationJobs": "Find AI translations by content short ID",
    "searchAlreadyExists": "Search with the same name already exists.",
    "searchArticles": "Find article by title",
    "searchCountdowns": "Find countdown by title",
    "searchItems": "Search {{ items }}",
    "searchProductRanges": "Search by name or short ID",
    "searchProducts": "Find product by name, model or codename",
    "searchProductsByCtn": "Find products by CTN",
    "searchPushMessages": "Find push notification by title or text",
    "seeAll": "See all",
    "select": {
      "country": "Select country",
      "domain": "Select domain",
      "type": "Select type"
    },
    "selectAll": "Select all",
    "selectAllFilteredOptions": "Select all filtered options",
    "selectAllOnThisPage": "Select all on this page",
    "selectApplianceFirst": "Select appliance first",
    "selectCountry": "Select country",
    "selectCountryProfile": "Select country profile",
    "selectStep": "Select a step",
    "selectTimeRange": "Select time range",
    "serving": {
      "plural": "servings"
    },
    "shopAnnouncement": {
      "plural": "Shop announcements"
    },
    "shortId": "Short ID",
    "shortIds": "Short IDs",
    "show": "Show",
    "showAll": "Show all {{ item }}",
    "showLess": "Show less",
    "showParameters": "Show parameters",
    "socialIndicators": "Social indicators",
    "source": "Source",
    "sourceAppliance": {
      "singular": "Source product"
    },
    "specificLanguage": "Specific language",
    "status": "Status",
    "stepByStep": "Step-by-step",
    "stepNumber": "Step number",
    "steps": "Steps",
    "subtitles": {
      "addNew": "Add new subtitle",
      "duplicateLanguageError": "Multiple subtitles with the same language were detected. There can be only one subtitle per language.",
      "empty": "No subtitles added.",
      "plural": "Subtitles",
      "selectFile": "Select subtitle file in .VTT format.",
      "videoChangeInfoMessage": "If the video changes, the subtitles will reset. Since subtitles are linked to the DAM video, any updates to them will appear wherever the video is used.",
      "view": "View subtitle",
      "viewDialogTitle": "Subtitle file content"
    },
    "survey": {
      "plural": "polls"
    },
    "surveyItemTranslationRequirement": "Each answer is required to have a title",
    "switchTo": "Switch to {{ item }}",
    "temperature": "Temperature",
    "tenSecondVideoInfoMessage": "Please use the videos with duration up to 10 seconds.",
    "time": "Time",
    "timeAndServings": "Time and servings",
    "timePublishedToCountry": "Time published to country",
    "timezone": "Timezone",
    "title": "Title",
    "to": "to",
    "toast": {
      "countryChanged": "Published countries changed successfully",
      "countryProfilesChanged": "Country profiles changed successfully"
    },
    "tool": {
      "plural": "Tools",
      "singular": "Tool"
    },
    "total": "Total",
    "translation": {
      "plural": "translations",
      "singular": "Translation"
    },
    "translationHasBeenDeleted": "The translation has been deleted",
    "troubleshootingArticles": {
      "label": "Troubleshooting articles",
      "tooltip": "Number of country/language combinations with at least one Troubleshooting article (not total Troubleshooting articles)"
    },
    "type": "Type",
    "unknownLabel": "Unknown label",
    "unlocked": "Unlocked",
    "unselectAll": "Unselect all",
    "unselectAllFilteredOptions": "Unselect all filtered options",
    "uploadImage": "Upload image",
    "uponApplianceChangeResult": "Upon changing appliances, all incompatible {{ items }} will be removed.",
    "userManuals": {
      "label": "User manuals",
      "tooltip": "Number of user manuals found for country/language combinations where device is available"
    },
    "validators": {
      "link": {
        "invalidProtocol": "Link can only accept URL address that starts with \"https\".",
        "invalidUrl": "URL address is not valid.",
        "required": "Link is required."
      }
    },
    "variant": {
      "plural": "Variants",
      "singular": "Variant"
    },
    "video": "Video",
    "videoDurationInfoMessage": "Please use the videos with duration up to {{ duration }} seconds.",
    "videos": {
      "plural": "Videos"
    },
    "damVideos": {
      "plural": "DAM videos"
    },
    "view": {
      "addAnnouncementContent": "Add announcement content",
      "addBasicInformation": "Add basic information",
      "author": "Author",
      "basicInformation": "Basic information",
      "countriesActivated": "Countries activated",
      "description": "Description",
      "designAndVisibility": "Design & visibility",
      "domainOwner": "Domain owner",
      "domainsAndCountriesPublished": "Domains and countries published",
      "lastModified": "Last modified",
      "sourceLanguage": "Source language",
      "statusChangedAt": "Changed at",
      "statusChangedBy": "Changed by",
      "tags": "Tags"
    },
    "viewBy": "View by",
    "viewComment": "View comment",
    "viewDetails": "View details",
    "viewItem": "View item",
    "watt": "W",
    "yes": "Yes",
    "notApplicable": "N/A"
  },
  "constraints": {
    "imageUpload": {
      "generic": {
        "description": "Image might be too large",
        "title": "Error while uploading image"
      },
      "maxResolution": {
        "description": "Please upload an image smaller than {{ maxWidth }}×{{ maxHeight }} px.",
        "title": "Image is too large"
      },
      "mimeType": {
        "description": "Please use images only in PNG or JPG format.",
        "title": "Image is not in supported format"
      },
      "ratio": {
        "description": "Please use images only in aspect ratio {{ ratioX }}:{{ ratioY }}.",
        "title": "Image is not in the right aspect ratio"
      },
      "resolution": {
        "description": "Please upload an image larger than {{ minWidth }}×{{ minHeight }} px.",
        "title": "Image is not large enough"
      },
      "size": {
        "description": "Maximum image size is 20MB",
        "title": "Image is too large"
      }
    }
  },
  "consumer": {
    "devices": "Consumer devices",
    "devicesWithSize": "Consumer devices ({{ size }})",
    "email": "E-mail",
    "followers": "Followers",
    "following": "Following",
    "id": "Consumer ID",
    "lastLoggedAt": "Last login",
    "mobileNumber": "Phone number",
    "name": "Name",
    "noComments": "Consumer did not write any comments",
    "noDevices": "Consumer has no devices",
    "noRecipes": "Consumer has no recipes",
    "recipePreparations": {
      "emptyState": "There are no images uploaded by this consumer",
      "title": "Recipe images by consumer"
    },
    "recipes": "Consumer recipes",
    "registeredAt": "Registered at"
  },
  "consumers": {
    "rightToBeForgotten": {
      "modalDescription": "The entire backend data, which is referring to the user, shall be deleted",
      "modalTitle": "Are you sure you want to delete this consumer?",
      "searchPlaceholder": "Search by name, e-mail, or phone number",
      "successToastMessage": "Consumer's status has been successfully changed to \"{{ status }}\""
    }
  },
  "content": {
    "toastMessage": {
      "translationSaved": "{{ content }} translation saved successfully."
    },
    "translation": {
      "isApproved": "Translation already approved"
    },
    "view": "View content"
  },
  "contentContainerContentType": {
    "video": "Video"
  },
  "contentContainerDeviceCategory": {
    "noResult": "No devices found for this category",
    "noResultForCategory": "There are no assigned devices for appliance: {{category}}"
  },
  "contentContainerTranslation": {
    "copyTranslations": "Copy translations",
    "copyTranslationsDescription": "Copy the content translations that are missing on this highlight and update the differing ones with new values.",
    "differentTranslations": "Differing translations",
    "missingTranslations": "Missing translations",
    "noMismatchedTranslations": "There are no translation mismatches",
    "title": "Title"
  },
  "contentDisplayType": {
    "articles": {
      "tooltip": "This value determines how mobile will render the article. If \"Step by step\" is selected, the main article description and main DAM video fields will be removed, as they are unused on mobile."
    },
    "errorMessage": "Display type is required",
    "formLabel": "Displayed as",
    "label": "Display type",
    "placeholder": "Select display type"
  },
  "contentDraftStatusReason": {
    "approvedButMovedForEditing": "Approved but moved to draft for editing",
    "justCreated": "Just created",
    "reportedAndEditRequested": "Reported and edit requested",
    "reviewRequestedButRejected": "Review requested but rejected",
    "takenOffline": "Taken offline"
  },
  "contentLock": {
    "errorDialog": {
      "description": "This {{ contentType }} is currently being edited by {{ name }} ({{ email }}). You cannot make changes until they are finished. Please try again later or contact the editor if urgent.",
      "title": "Editing restricted"
    },
    "warningMessage": "Editing is disabled as {{ name }} ({{ email }}) is currently editing this {{ contentType }} since {{ date }}."
  },
  "contentProductsForm": {
    "accessories": {
      "error": "Select \"Appliances\" and \"Devices\" first",
      "placeholder": "Choose accessories"
    },
    "devices": {
      "error": "Select \"Appliances\" first",
      "placeholder": "Choose devices"
    }
  },
  "contentPublishing": {
    "dialog": {
      "description": "You are about to leave this screen and discard the publishing information you entered. Do you want to save the publishing changes?",
      "title": "Save the publishing information?"
    },
    "emptyState": {
      "message": "Select desired Content and Profile in order to manage publishing"
    },
    "inactiveCountriesFilter": {
      "label": "Inactive countries ({{ number }})"
    },
    "problemLevel": {
      "error": "Not publishable",
      "info": "Publishable without warnings",
      "warning": "Publishable with warnings"
    },
    "profiles": {
      "label": "Profiles"
    },
    "publicationChange": {
      "emptyState": "There are no countries available for publishing",
      "radio": {
        "label": "Do you want to republish it as a new content?",
        "no": "No",
        "tooltip": "This content is already published. Do you want to republish it as a new content?",
        "yes": "Yes"
      },
      "sectionLabel": "Select the countries you want to publish to or deselect if you want to unpublish"
    },
    "toastMessage": {
      "changesDiscarded": "Publishing information changes have been discarded",
      "error": "Error occurred while saving publications",
      "success": "Publications are successfully updated"
    },
    "viewContent": "View content"
  },
  "contentScheduler": {
    "confirmationDialog": {
      "description": {
        "remove": "Are you sure you want to remove this event?",
        "schedule": "Are you sure you want to schedule this event?",
        "unschedule": "Are you sure you want to unschedule this event?"
      }
    },
    "domainFilter": "Filter by domain",
    "eventMainStatus": {
      "active": "Active",
      "finished": "Finished"
    },
    "eventStatus": {
      "draft": "draft",
      "failed": "failed",
      "inProgress": "In progress",
      "partiallySuccessful": "Partially successful",
      "passed": "past event",
      "scheduled": "scheduled",
      "successful": "Successful"
    },
    "publishingProblemsModal": {
      "statusReportsTitle": "Status reports"
    },
    "scheduledEvent": "Scheduled event",
    "schedulerEventFilter": {
      "all": "All",
      "label": "Scheduling event actions",
      "publishingOnly": "Publishing only",
      "unpublishingOnly": "Unpublishing only"
    },
    "successToast": {
      "remove": "The event was removed successfully",
      "schedule": "You successfully scheduled content for {{ date }}",
      "unschedule": "The event was unscheduled successfully"
    },
    "title": "Content scheduler"
  },
  "contentSearch": {
    "missingLanguage": "Select language first",
    "placeholder": "Search"
  },
  "contentSelector": {
    "contentSearch": {
      "placeholder": "Choose content"
    }
  },
  "contentStatus": {
    "approve": {
      "content": "You are about to approve this {{ content }}. Please enter your approval reason:",
      "title": "{{ content }} approval"
    },
    "deflag": {
      "content": "You are about to deflag this {{ content }} and move it back to Live. Please enter your reason:",
      "title": "Deflagging {{ content }}"
    },
    "delete": {
      "content": "Are you sure you want to delete this {{ content }}?",
      "title": "{{ content }} deletion"
    },
    "deleteReportedContent": {
      "content": "Please select the reason (the reason will be visible to consumer):"
    },
    "failedStatusChange": {
      "toast": "{{ content }} status has not been changed to \"{{ status }}\" due to an error"
    },
    "flag": {
      "content": "You are about to flag this {{ content }}. Please select your reason:",
      "title": "Flag {{ contentTitle }} {{ content }}"
    },
    "moveToDraft": {
      "content": "You are about to move this {{ content }} to draft. Please enter your reason:",
      "title": "{{ content }} draft"
    },
    "moveToLive": {
      "content": "You are about to make this {{ content }} live. Please enter your reason:",
      "title": "Moving the {{ content }} to live",
      "warning": "The {{ content }} has translations that are still in the draft status"
    },
    "reject": {
      "content": "You are about to reject this request. Please enter your rejection reason:",
      "title": "Reject approving request"
    },
    "requestEdit": {
      "content": "Please select the reason (the reason will be visible to consumer):",
      "title": "Request edit"
    },
    "requestReview": {
      "content": "You are about to move {{ content }} in review. Please enter your reason:",
      "title": "Move to in review"
    },
    "successStatusChange": {
      "toast": "{{ content }} status has been successfully changed to \"{{ status}}\""
    },
    "takeOffline": {
      "content": "You are about to unpublish the {{ content }} from all of the country profiles. Please enter your reason:",
      "title": "Taking the {{ content }} offline"
    }
  },
  "contentTranslations": {
    "addFilesForImport": "Add files for import",
    "clickSelectFileOrDrag": "Click select file or drag and drop your {{ fileTypes }} files",
    "import": "Import",
    "importTitle": "Import translations from files",
    "missingTranslations": "Missing translations",
    "moveToDraftAndEdit": "Please move the content to draft and edit listed fields before saving the translation.",
    "populateWith": "Populate with",
    "translationFiles": "Translation files"
  },
  "contentType": {
    "announcement": "Announcement",
    "article": "Article",
    "articleCollection": "Article collection",
    "campaign": "Campaign",
    "collection": "recipe book",
    "countdown": "Countdown",
    "easyRecipeBook": "Easy recipe book",
    "healthClaimGuideline": "Health claim guideline",
    "highlight": "Highlight",
    "nutritionClaimContent": "Nutrition claim content",
    "onboardingAnnouncement": "Onboarding announcement",
    "packHolder": "Recipe book pack",
    "pinnedHolder": "Pinned recipe book",
    "productRecipeList": "Product recipe list",
    "promoCode": "Promo code",
    "pushMessage": "Push message",
    "recipe": "recipe",
    "recipeBook": "Recipe book",
    "recipeBookCarousel": "Recipe book carousel",
    "recipeCarousel": "Recipe carousel",
    "shopAnnouncement": "Shop announcement",
    "survey": "Poll",
    "video": "Video"
  },
  "contentTypeHal": {
    "announcement": "Announcement",
    "article": "Article",
    "collection": "Recipe book",
    "highlight": "Highlight",
    "pushMessage": "Push notification",
    "recipe": "Recipe"
  },
  "cookingVariable": {
    "addNewCookingVariable": "Add new source product",
    "addNewSegment": "Add another set of parameters",
    "airSpeed": {
      "label": "Air speed",
      "placeholder": "Choose air speed"
    },
    "buildDuration": {
      "label": "Build pressure time"
    },
    "childCookingMethods": {
      "label": "Sub-Cooking method",
      "placeholder": "Choose sub-cooking method"
    },
    "cookingMethods": {
      "label": "Cooking method",
      "placeholder": "Choose cooking method"
    },
    "deleteDialog": {
      "description": "Are you sure you want to delete this source product?",
      "title": "Delete source product"
    },
    "duplicateDialog": {
      "description": {
        "confirmation": "Do you want to automatically add the same source product and product range with the {{ voltage }} electric system and with the same recipe parameters?",
        "info": "Airfryer devices from the Compact range do not have an impact on the recipe parameters in terms of voltage."
      },
      "title": "Duplicate for {{ voltage }} electric system?"
    },
    "duration": {
      "label": "Duration",
      "maxDeviceLimit": {
        "temperatureOver": "Maximum cooking time for temperature {{ temperature }} and over is {{ duration }}",
        "temperatureUnder": "Maximum cooking time for temperature under {{ temperature }} is {{ duration }}"
      }
    },
    "editCookingVariable": "Edit source product",
    "errors": {
      "genericNotInInterval": "{{ fieldName }} must be in increments of {{ interval }} {{ unit }}",
      "mustBeExact": "{{ field }} must be {{ value }}",
      "mustBeGreaterOrEqualThan": "{{ field }} must be greater than or equal to {{ min }}",
      "mustBeGreaterThan": "{{ field }} must be greater than {{ min }}",
      "mustBeInRange": "{{ field }} must be between {{ min }} and {{ max }}",
      "mustBeLowerOrEqualThan": "{{ field }} must be lower than or equal to {{ max }}",
      "mustBeLowerThan": "{{ field }} must be lower than {{ max }}",
      "notInIterval": "Temperature must be in increments of {{ interval }} {{ unit }}"
    },
    "humidity": {
      "high": {
        "label": "High"
      },
      "label": "Humidity",
      "medium": {
        "label": "Medium"
      },
      "off": {
        "label": "Off"
      },
      "placeholder": "Choose humidity"
    },
    "humidityLevel": {
      "high": {
        "label": "High"
      },
      "label": "Humidity",
      "medium": {
        "label": "Medium"
      },
      "off": {
        "label": "Off"
      },
      "placeholder": "Choose humidity"
    },
    "multiCrisp": {
      "label": "MultiCrisp"
    },
    "multipleParameterSets": "Multiple parameter sets",
    "numberOfShakes": {
      "label": "No. of shakes"
    },
    "pan": {
      "label": "Pan"
    },
    "power": {
      "label": "Power",
      "placeholder": "00"
    },
    "powerMode": {
      "label": "Power Mode"
    },
    "pressure": {
      "label": "Pressure",
      "placeholder": "0"
    },
    "profileClearConfirmationMessage": "This will clear current cooking profile settings. Are you sure you wish to continue?",
    "releaseDuration": {
      "label": "Release pressure time"
    },
    "speed": {
      "label": "Speed"
    },
    "temperature": {
      "label": "Temperature"
    },
    "temperatureInCelsius": {
      "label": "Temperature"
    },
    "warnings": {
      "genericNotInInterval": "{{ fieldName }} should be in increments of {{ interval }} {{ unit }}",
      "notInIterval": "{{ field }} should be in increments of {{ interval }} {{ unit }}",
      "shouldBeExact": "{{ field }} should be {{ value }}",
      "shouldBeGreaterOrEqualThan": "{{ field }} should be greater than or equal to {{ min }}",
      "shouldBeGreaterThan": "{{ field }} should be greater than {{ min }}",
      "shouldBeInRange": "{{ field }} should be between {{ min }} and {{ max }}",
      "shouldBeLowerOrEqualThan": "{{ field }} should be lower than or equal to {{ max }}",
      "shouldBeLowerThan": "{{ field }} should be lower than {{ max }}"
    }
  },
  "copyToClipboard": {
    "generic": "Copy {{item}} to clipboard",
    "label": {
      "link": "Copy link",
      "model": "Copy model",
      "shortID": "Copy short ID"
    }
  },
  "countdown": {
    "countDirection": {
      "countDown": "Starts in",
      "countUp": "Ends in",
      "label": "Count direction"
    },
    "endDateTime": {
      "label": "End time"
    },
    "preview": {
      "selectDisplayedAt": "Enable the preview by selecting where countdown will be displayed."
    },
    "startDateTime": {
      "label": "Start time"
    },
    "timeScope": {
      "global": "Global",
      "label": "Time scope",
      "local": "Local"
    },
    "timezoneInfoLabel": "Start and end time depend on the Time Scope: if Global, time is selected in the UTC timezone; if Local, time is recalculated to the timezone of the country where the countdown will be published.",
    "useCase": {
      "default": "Home screen",
      "label": "Displayed on",
      "singleArticle": "Single article"
    }
  },
  "countries": {
    "searchPlaceholder": "Find country by name or code"
  },
  "country": {
    "appliancesPlaceholder": "Choose appliance(s)",
    "code": "Country code",
    "codePlaceholder": "Enter country code",
    "communityPlaceholder": "Choose community availability",
    "confirmActivationModal": {
      "content": "Activating a country enables content to be assigned to that country, and importing and exporting translations for this country’s assigned languages. ",
      "title": "Activating a country"
    },
    "details": "Country details",
    "deviceRegion": {
      "china": "China",
      "label": "Device region",
      "placeholder": "Choose device region",
      "world": "World"
    },
    "edit": "Edit country",
    "errors": {
      "couldNotActivate": "Could not activate the country due to an error."
    },
    "features": {
      "airQualityIndex": {
        "AQI_AU": "AQI_AU",
        "AQI_CA": "AQI_CA",
        "AQI_CN": "AQI_CN",
        "AQI_NL": "AQI_NL",
        "AQI_US": "AQI_US",
        "CAQI_EU": "CAQI_EU",
        "DAQI_UK": "DAQI_UK",
        "NAQI_IN": "NAQI_IN",
        "label": "Air quality index",
        "placeholder": "Choose air quality index"
      },
      "basic": "Basic",
      "community": "Community",
      "iap": {
        "ECOMMERCE": "Ecommerce",
        "IN_STORE": "In store",
        "MARKETPLACE": "Marketplace",
        "RETAILER": "Retailer",
        "label": "IAP",
        "placeholder": "Choose IAP"
      },
      "label": "Country features",
      "replenishment": {
        "AMAZON_DART": "Amazon dart",
        "label": "Replenishment",
        "placeholder": "Choose replenishment"
      },
      "voiceProvider": {
        "AMAZON_ALEXA": "Amazon Alexa",
        "label": "Voice provider",
        "placeholder": "Choose voice provider"
      }
    },
    "languages": "Country languages",
    "links": "Country links",
    "marketingOptIn": {
      "label": "Marketing opt-in",
      "placeholder": "Choose marketing opt-in availability"
    },
    "name": "Country name",
    "namePlaceholder": "Enter country name",
    "profile": {
      "isNotVisibleInCarousel": "Not visible",
      "isVisibleInCarousel": "Visible",
      "visible": "Visible in carousel"
    },
    "supportedLanguages": "Supported languages",
    "timeZone": {
      "label": "Default timezone"
    },
    "toastMessage": {
      "saved": "Country saved"
    },
    "unitSystem": "Unit System",
    "unitSystemPlaceholder": "Choose unit system"
  },
  "countryName": {
    "AA": "Global",
    "AE": "United Arab Emirates",
    "AL": "Albania",
    "AO": "Angola",
    "AQ": "Global",
    "AR": "Argentina",
    "AT": "Austria",
    "AU": "Australia",
    "BA": "Bosnia-Herzegovina",
    "BE": "Belgium",
    "BG": "Bulgaria",
    "BH": "Bahrain",
    "BN": "Brunei",
    "BR": "Brazil",
    "CA": "Canada",
    "CH": "Switzerland",
    "CL": "Chile",
    "CN": "China",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DE": "Germany",
    "DK": "Denmark",
    "EE": "Estonia",
    "EG": "Egypt",
    "ES": "Spain",
    "FI": "Finland",
    "FR": "France",
    "GB": "United Kingdom",
    "GH": "Ghana",
    "GR": "Greece",
    "HK": "Hong Kong",
    "HR": "Croatia",
    "HU": "Hungary",
    "ID": "Indonesia",
    "IE": "Ireland",
    "IH": "HomeID Team IHUT",
    "II": "HomeID Team Nederland (IHUT)",
    "IJ": "HomeID Team 中国 (IHUT)",
    "IL": "Israel",
    "IN": "India",
    "IS": "Iceland",
    "IT": "Italy",
    "JO": "Jordan",
    "KE": "Kenya",
    "KH": "Cambodia",
    "KR": "South Korea",
    "KW": "Kuwait",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "LV": "Latvia",
    "MD": "Moldova",
    "ME": "Montenegro",
    "MK": "North Macedonia",
    "MO": "Macau",
    "MU": "Mauritius",
    "MX": "Mexico",
    "MY": "Malaysia",
    "NA": "Namibia",
    "NG": "Nigeria",
    "NL": "Netherlands",
    "NO": "Norway",
    "NZ": "New Zealand",
    "OM": "Oman",
    "PE": "Peru",
    "PH": "Philippines",
    "PK": "Pakistan",
    "PL": "Poland",
    "PT": "Portugal",
    "QA": "Qatar",
    "QM": "HomeID Team Austria (IHUT)",
    "QN": "Test country",
    "RO": "Romania",
    "RS": "Serbia",
    "RU": "Russia",
    "SA": "Saudi Arabia",
    "SD": "Sudan",
    "SE": "Sweden",
    "SG": "Singapore",
    "SI": "Slovenia",
    "SK": "Slovakia",
    "TH": "Thailand",
    "TR": "Turkey",
    "TW": "Taiwan",
    "UA": "Ukraine",
    "US": "United States of America",
    "UY": "Uruguay",
    "VN": "Vietnam",
    "XK": "Kosovo",
    "ZA": "South Africa"
  },
  "countryProfile": {
    "plural": "Country profiles",
    "singular": "Country profile"
  },
  "cropping": {
    "crop": "Crop",
    "cropping": "Cropping image",
    "preparing": "Preparing cropper",
    "warning": {
      "keepCroppingButton": "Keep cropping",
      "leaveButton": "Leave anyway",
      "leaveContent": "You are currently cropping an image. Leaving will not save the image that is being cropped.",
      "saveButton": "Save anyway",
      "saveContent": "You are currently cropping an image. Image that is currently being cropped will not be saved.",
      "title": "Image is being cropped"
    }
  },
  "customTable": {
    "action": {
      "createNewTableRow": "Create new table row",
      "deleteTableAndData": "Delete the table and table data",
      "importData": "Import table data",
      "overwriteData": "Overwrite table data",
      "tableContent": "Table content"
    },
    "column": {
      "addNew": "Add new column",
      "allowedValues": {
        "label": "Allowed values",
        "placeholder": "value1,value2,value3",
        "required": "Allowed values are required",
        "tooltip": "Allowed values separated by a comma"
      },
      "description": {
        "placeholder": "Enter column description"
      },
      "name": {
        "label": "Column name",
        "noWhitespace": "Column name must not contain whitespace characters",
        "placeholder": "Enter column name"
      },
      "nullable": {
        "label": "Is nullable?"
      },
      "type": {
        "label": "Column type",
        "placeholder": "Select column type"
      }
    },
    "deleteTableRowDialog": {
      "description": "Are you sure you want to delete the table row?",
      "title": "Table row deletion"
    },
    "displayName": {
      "placeholder": "Enter display name"
    },
    "form": {
      "create": "Create custom table",
      "edit": "Edit custom table"
    },
    "header": {
      "columnName": "Column name",
      "columnType": "Column type",
      "isNullable": "Nullable"
    },
    "import": {
      "buttonLabel": "Import data",
      "description": "This action will overwrite the previous table data. The previous table data will be lost. Do you want to proceed with the action?",
      "modalTitle": "Import table data",
      "success": "Table data successfully imported"
    },
    "row": {
      "formTitle": "Table row form"
    },
    "rowValidation": {
      "allowedValues": "The entered value is not allowed"
    },
    "subtitle": {
      "columns": "Table columns",
      "dangerZone": "Danger zone"
    },
    "tableData": {
      "export": "Export table data",
      "noColumns": "Table columns are not defined",
      "noData": "There is no data in the table"
    },
    "tableDeletion": {
      "description": "This action is irreversible. The table and all of its data will be deleted. Do you want to proceed with the deletion?",
      "title": "Table deletion"
    },
    "tableRow": {
      "deleted": "The table row has been deleted",
      "saved": "Table row has been successfully saved"
    },
    "toastMessage": {
      "saved": "Table definition saved"
    },
    "uniqueIdentifier": {
      "label": "Unique identifier",
      "placeholder": "Enter unique table identifier"
    },
    "validation": {
      "displayNameRequired": "Display name is required",
      "uniqueIdentifier": "Unique table identifier is required",
      "uniqueIdentifierNoWhitespace": "Unique identifier must not contain whitespace characters"
    }
  },
  "customTables": {
    "actions": {
      "editDefinition": "Edit definition"
    },
    "header": {
      "displayName": "Table name",
      "uniqueIdentifier": "Unique identifier"
    }
  },
  "dashboard": {
    "statistics": {
      "total": "TOTAL"
    }
  },
  "dateRangePicker": {
    "tooltip": {
      "bothDatesRequired": "For a date range to be applied, both start and end date must be entered"
    }
  },
  "datetimepicker": {
    "date": {
      "label": "Date",
      "placeholder": "Choose date"
    },
    "time": {
      "label": "Time",
      "placeholder": "Choose time"
    }
  },
  "deepLink": {
    "campaign": {
      "label": "Campaign"
    },
    "channel": {
      "announcements": "Announcements",
      "countdown": "Countdown",
      "email": "Email",
      "inAppMessages": "In-app Messages",
      "instagram": "Instagram",
      "label": "Channel",
      "pushNotifications": "Push Notifications",
      "shopAnnouncement": "Shop Announcement",
      "socialMediaInfluencers": "Social Media – Influencers",
      "tikTok": "TikTok"
    },
    "dialog": {
      "generate": "Generate",
      "title": "Generate deeplink"
    }
  },
  "deepLinkGenerator": {
    "copied": "Link copied to clipboard: {{ link }}",
    "modal": {
      "description": "We've generated a URL link that leads to this content's mobile screen. You can copy the link to your clipboard by clicking the button next to the URL.",
      "title": "Mobile app deep link URL"
    },
    "profileHeader": "Deeplink",
    "tooltip": {
      "content": "Generate a new URL to the mobile application for this content",
      "profile": "Generate a new URL to the mobile application for this profile"
    }
  },
  "deleteSearch": {
    "description": "This action can’t be undone. ",
    "title": "Delete “{{ name }}” search"
  },
  "device": {
    "externalApplication": {
      "label": "External application",
      "placeholder": "Select an external application"
    },
    "externalDeviceId": "Ext. device ID",
    "firmware": "Firmware",
    "isPrimary": "Primary device",
    "mandatoryUpgrade": "Mandatory upgrade",
    "migration": "Migration",
    "migrationDetails": "Migration details",
    "registeredIn": "Registered in",
    "toggleMigrationDetails": "Toggle migration details",
    "upgradeMethod": "Upgrade method"
  },
  "deviceNetworkConfig": {
    "ipAddress": "IP Address",
    "modelId": "Model ID",
    "prefix": "Bluetooth prefix",
    "productId": "Product ID",
    "remove": "Remove network config",
    "ssid": "SSID",
    "title": "Network config",
    "type": {
      "ble": "Bluetooth",
      "tuyaBle": "Tuya Bluetooth",
      "wifi": "Wi-Fi"
    }
  },
  "deviceProperty": {
    "invalidInterval": "Interval value must be greater than 0",
    "invalidMaxInterval": "The max value must be in steps of the provided interval.",
    "invalidMinInterval": "The min value must be in steps of the provided interval.",
    "minLessThanOne": "Min value must be greater than 0.",
    "minMaxMismatch": "Min value must be less than max value."
  },
  "domain": {
    "singular": "Domain"
  },
  "domainName": {
    "africa": "Africa",
    "apac": "APAC",
    "australia": "Australia",
    "baltic": "Baltic",
    "benelux": "BENELUX",
    "cee": "CEE",
    "ceer": "CEER",
    "china": "China",
    "dach": "DACH",
    "france": "France",
    "global": "Global",
    "greece": "Greece",
    "iberia": "Iberia",
    "ihut": "IHUT",
    "iig": "IIg",
    "it": "IT",
    "latam": "Latin America",
    "met": "MET",
    "meta": "META",
    "middleeast": "Middle East",
    "nordics": "Nordics",
    "northamerica": "North America",
    "poland": "Poland",
    "singapore": "Singapore",
    "southkorea": "South Korea",
    "turkey": "Turkey",
    "uki": "UKI",
    "unitedarabemirates": "United Arab Emirates"
  },
  "duration": {
    "validation": {
      "isDurationInMinutes": {
        "message": "The duration must be a whole number or a rounded minute value."
      }
    }
  },
  "electricSystem": {
    "110V": {
      "longLabel": "Low voltage (100-127 V)",
      "shortLabel": "Low voltage"
    },
    "220V": {
      "longLabel": "High voltage (220-240 V)",
      "shortLabel": "High voltage"
    },
    "label": "Electric system",
    "placeholder": "Select electric system"
  },
  "error": {
    "generic": "Error",
    "hasErrors": "{{ item }} has errors",
    "httpResponse": "Server responded:",
    "http_0": "Something went wrong",
    "http_400": "Bad request",
    "http_401": "Unauthorized",
    "http_403": "Forbidden",
    "http_404": "Item not found",
    "http_500": "Internal server error",
    "http_503": "Service unavailable",
    "isRequired": "{{ item }} is required",
    "itemExists": "Item already exists",
    "maxLength": "Number of characters cannot exceed {{length}} ",
    "mustBeGreaterThan": "{{ field }} must be greater than {{ min }}"
  },
  "exportRecipeModal": {
    "includeMedia": "Include images & video URLs"
  },
  "exportTranslationsDialog": {
    "referenceLanguage": "Reference Language",
    "selectReferenceLanguage": "Select the reference language for export"
  },
  "fileUploader": {
    "deleteImageDialog": {
      "description": "Are you sure you want to delete this image?",
      "title": "Image deletion"
    },
    "importResultLevel": {
      "errors": "Errors",
      "warnings": "Warnings"
    },
    "uploadFailed": "Upload failed",
    "uploadSuccessful": "Upload successful",
    "uploading": "Uploading..."
  },
  "filter": {
    "accessories": {
      "label": "Accessories",
      "notFound": "No accessories found"
    },
    "announcementType": "Announcement type",
    "articleType": "Article type",
    "category": "Category",
    "commentState": "Comment state",
    "contentOwnerType": {
      "homeId": "HomeID",
      "label": "Content owner type",
      "userManaged": "User managed"
    },
    "country": "Country",
    "dateCreated": {
      "label": "Date created",
      "options": {
        "lastWeek": "Last week",
        "lastYear": "Last year",
        "thisMonth": "This month",
        "thisWeek": "This week",
        "thisYear": "This year"
      }
    },
    "devices": "Product model",
    "domain": "Domain",
    "featured": {
      "isFeatured": "Is featured",
      "isNotFeatured": "Is not featured",
      "label": "Featured"
    },
    "language": "Language",
    "lockedIngredient": {
      "label": "Locked status",
      "locked": "Locked",
      "unlocked": "Unlocked"
    },
    "notInDatabases": "Not in databases",
    "nutritionDatabase": "Nutrition database",
    "ownerType": "Owner type",
    "pinned": {
      "isNotPinned": "Is not pinned",
      "isPinned": "Is pinned",
      "label": "Pinned"
    },
    "publishedAt": "Time published to profile",
    "publishedInCountry": "Published in country",
    "qualityIndicator": {
      "calorieDifference": "kcal mismatch among databases",
      "fat": "High in fat",
      "label": "Quality indicator",
      "protein": "High in protein",
      "sodium": "High in sodium"
    },
    "reported": {
      "label": "Reported",
      "no": "Not reported",
      "yes": "Reported"
    },
    "role": "Role",
    "status": "Status",
    "tags": {
      "label": "Tags",
      "notFound": "No tags found",
      "selectDevice": "Select appliance first"
    },
    "topLevelOnly": {
      "allLevels": "Comment and replies",
      "label": "Comment levels",
      "onlyTopLevel": "Only top-level comments"
    },
    "translatable": {
      "label": "Translatable status",
      "notTranslatable": "Not translatable",
      "translatable": "Translatable"
    },
    "useInRecipes": {
      "label": "Use in recipes",
      "onlyUnused": "Only unused ingredients",
      "onlyUsed": "Only used ingredients"
    },
    "video": {
      "doesNotHaveVideo": "Does not have video",
      "hasVideo": "Has video",
      "label": "Video"
    }
  },
  "filterCreator": {
    "appliance": {
      "label": "Appliance",
      "placeholder": "Choose appliance"
    },
    "domain": {
      "label": "Domain",
      "placeholder": "Choose domain"
    },
    "language": {
      "label": "Language",
      "placeholder": "Choose language"
    },
    "languageStatus": {
      "label": "Language status",
      "placeholder": "Choose language status"
    },
    "ownerType": {
      "label": "Owner type",
      "placeholder": "Choose owner type"
    },
    "resourceType": {
      "label": "Content type",
      "placeholder": "Choose content type"
    },
    "status": {
      "label": "Status",
      "placeholder": "Choose status"
    }
  },
  "filters": {
    "notPublishedByProfile": "Not published by profile",
    "notPublishedInCountry": "Not published in country",
    "publishedByProfile": "Published by profile"
  },
  "food": {
    "translation": {
      "areYouSureDeleteTranslation": "Are you sure you want to delete the food translation?",
      "deletion": "Food translation deletion"
    }
  },
  "fractionForm": {
    "errors": {
      "greatherThanZero": "All numbers must be greather than 0",
      "notANumber": "Input is not a valid number",
      "numeratorOrDenominatorTooHigh": "Numerator and denominator must be less than {{ max }}",
      "numeratorTooHigh": "Numerator must be lower than denominator",
      "partialFraction": "Both part of the fraction needs to be entered",
      "required": "Amount is required"
    }
  },
  "gram": {
    "abbreviation": "g"
  },
  "highlight": {
    "browse": {
      "title": "Browse highlights"
    },
    "details": "Highlight details",
    "noResultsTitle": "No highlight found for  '{{ query }}'",
    "preview": {
      "disableSound": "Disable sound",
      "enableSound": "Enable sound",
      "fullscreen": "Fullscreen preview",
      "homepage": "Homepage preview"
    }
  },
  "highlights": {
    "copyContentTranslationsDescription": "Do you want to copy all the translations from the selected content to the highlight? If yes, highlight translations will be created from content translations, and will be pre-populated with the content translation title and language."
  },
  "history": {
    "event": {
      "commentDeflag": "Comment deflagged",
      "commentDelete": "Comment deleted",
      "contentStatusChange": "Status changed",
      "contentStatusChangedTo": "Status changed to",
      "deviceActivate": "Device activated",
      "deviceDeactivate": "Device deactivated",
      "ingredientsAnalyzed": "Ingredients analysed",
      "label": "Event",
      "missingUnitDetected": "Missing unit detected",
      "productAvailabilityUpdate": "Product availability updated",
      "productBrandUpdate": "Product brand updated",
      "productUpdate": "Product updated",
      "profileStatusChange": "Status changed",
      "publish": "Published",
      "unpublish": "Unpublished"
    },
    "newStatus": "New status",
    "noHistory": "No history"
  },
  "imageUpload": {
    "fixedSizeValidationMessage": "You can upload only PNG or JPG images of size {{ minWidth }}×{{ minHeight }}px",
    "validationMessage": "You can upload only PNG or JPG images larger than {{ minWidth }}×{{ minHeight }}px and with ratio {{ ratioX }}×{{ ratioY }}",
    "validationMessageWithoutRatio": "You can upload only PNG or JPG images larger than {{ minWidth }}×{{ minHeight }}px"
  },
  "importResultType": {
    "descriptionLengthExceedsMaxValue": "Description exceeds maximum character limit",
    "invalidFileProvided": "Invalid file provided",
    "invalidTranslationProvided": "Invalid translation provided",
    "languageNotSupported": "Language is not supported",
    "numberStepTranslationDoesNotMatchSource": "Number of steps in the translation does not match the source",
    "sourceMissing": "Source missing",
    "sourceTranslationChanged": "Source translation changed",
    "sourceTranslationMissing": "Source translation missing",
    "targetLanguageMatchesSourceLanguage": "Target language matches the source language",
    "targetTranslationMissing": "Target translation missing",
    "titleLengthExceedsMaxValue": "Title exceeds maximum character limit",
    "translationImported": "Translation imported",
    "translationStillMissing": "Translation still missing",
    "translationUpdated": "Translation updated",
    "userDoesNotHavePermissionToImport": "User does not have permission to import"
  },
  "ingredient": {
    "addNew": {
      "default": "Add new ingredient"
    },
    "addToRecipe": {
      "amountMetric": "Amount (metric)",
      "name": "Ingredient name",
      "new": {
        "add": "Add \"{{ newIngredientName }}\" as ingredient"
      },
      "usCustomary": "Amount (US customary)"
    },
    "allAppliances": "All appliances",
    "allergens": {
      "approveModalDescription": "You are about to approve food sensitivites and intolerances of this ingredient. Please enter your approval reason:",
      "approveModalTitle": "Approve food sensitivites and intolerances",
      "approved": "Food sensitivities and intolerances are approved.",
      "history": {
        "approved": "Approved Food sensitivities and intolerances.",
        "unapproved": "Unapproved Food sensitivities and intolerances."
      },
      "notApproved": "Food sensitivities and intolerances are not approved.",
      "otherLabel": "Other",
      "otherPlaceholder": "Select other",
      "unapproveModalDescription": "You are about to unapprove food sensitivites and intolerances of this ingredient. Please enter your unapproval reason:",
      "unapproveModalTitle": "Unapprove food sensitivites and intolerances"
    },
    "applianceType": "Appliance type",
    "author": {
      "label": "Ingredient author"
    },
    "choose": "Choose ingredient",
    "comment": {
      "noComment": "There are no comments on this ingredient",
      "placeholder": "Use this text area to enter comments about changes to the ingredient",
      "title": "Comments"
    },
    "create": "Create ingredient",
    "creator": {
      "admin": "Philips",
      "consumer": "Consumer",
      "table": {
        "admin": "P",
        "consumer": "C",
        "unknown": "-"
      },
      "unknown": "Not specified"
    },
    "delete": {
      "description": "Are you sure you wish to delete this ingredient?",
      "success": "Ingredient was successfully deleted.",
      "title": "Delete ingredient"
    },
    "details": {
      "title": "Ingredient details"
    },
    "displayName": "Display name",
    "findPlaceholder": "Find ingredient by text or ID",
    "history": "Ingredient history",
    "id": {
      "label": "Ingredient ID"
    },
    "ingredientTranslations": {
      "deleteModalTitle": "Deleting translation",
      "title": "Ingredient translations",
      "validator": {
        "plural": "Ingredient must have a translation for plural in language {{ language }}.",
        "singular": "Ingredient must have a translation for singular in language {{ language }}."
      }
    },
    "isInNutritionDatabase": "Is in nutrition database",
    "isNotInNutritionDatabase": "Is not in nutrition database",
    "isNotMappedToDatabase": "Is not mapped to database {{ database }}",
    "lock": "Lock ingredient",
    "locked": "Locked status",
    "lockedIngredient": {
      "history": {
        "approved": "Locked ingredient.",
        "unapproved": "Unlocked ingredient."
      },
      "tooltip": "If ingredient is locked it can not be deleted."
    },
    "merge": {
      "authorConflict": {
        "title": "Choose the author of the ingredient"
      },
      "conflictTitle": "Resolve conflict cases",
      "nutritionInfoConflict": {
        "title": "Choose which database mappings you want to keep"
      },
      "specificConversionConflict": {
        "title": "Choose which conversions you want to keep"
      },
      "translationConflict": {
        "title": "Choose which translations you want to keep"
      }
    },
    "mergeErrorModalTitle": "Error while replacing ingredient",
    "mergeModelTitle": "Replace “{{ ingredient }}” ingredient with",
    "mergeSuccessModalButton": "View ingredient",
    "mergeSuccessModalButtonToBrowse": "Browse ingredients",
    "mergeSuccessModalContent": "The ingredient was replaced with the {{ title }} ({{ id }}).",
    "mergeSuccessModalTitle": "Ingredient replaced",
    "missingMappings": {
      "long": "Please add nutritional database mappings for databases: {{ databases }}.",
      "modalTitle": "Ingredient is missing some database mappings",
      "short": "Missing mappings for databases: {{ databases }}"
    },
    "nameConflict": "Conflicting with another ingredient",
    "nameOrId": "Ingredient name or ID",
    "namePlural": {
      "label": "Name plural",
      "placeholder": "Enter name in plural",
      "required": "Name plural is required"
    },
    "nameSingular": {
      "label": "Name singular",
      "placeholder": "Enter name in singular",
      "required": "Name singular is required"
    },
    "noRecipes": "Ingredient is not used in any recipes.",
    "noResults": "No ingredients found",
    "noTranslations": {
      "description": "There is no translations for this ingredient",
      "title": "No translations"
    },
    "notTranslatable": {
      "history": {
        "approved": "Changed translatable status to not translatable.",
        "unapproved": "Changed translatable status to translatable."
      },
      "label": "Not translatable",
      "mergeTitle": "Choose which value you want to keep",
      "message": "Ingredient is not translatable.",
      "tooltip": "If ingredient is marked as not translatable its translation won’t be exported by default."
    },
    "nutritionMapping": {
      "addMapping": "Add nutrition mapping",
      "approveModalDescription": "You are about to approve nutrition information of this ingredient. Please enter your approval reason:",
      "approveModalTitle": "Approve nutrition information",
      "approved": "Nutrition information is approved.",
      "deleteModalTitle": "Deleting nutrition information mapping",
      "history": {
        "approved": "Approved Nutritional information.",
        "unapproved": "Unpproved Nutritional information."
      },
      "missing": {
        "description": "There is no nutritional information for this ingredient. Go to edit screen to add it."
      },
      "noMappings": "Nutritional information not available",
      "noResultInDatabase": "No nutrition info found in selected database",
      "notApproved": "Nutrition information is not approved.",
      "providerName": "Ingredient name",
      "providerNamePlaceholder": "Enter provider ingredient name",
      "sourceDatabase": "Source database",
      "sourceDatabasePlaceholder": "Select database",
      "tableHeader": {
        "ifc": "IFC",
        "providerText": "Provider text",
        "quantity": "Ref. quantity",
        "source": "Source",
        "unit": "Ref. unit"
      },
      "title": "Nutritional information",
      "unapproveModalDescription": "You are about to unapprove nutrition information of this ingredient. Please enter your unapproval reason:",
      "unapproveModalTitle": "Unapprove nutrition information"
    },
    "nutritionalBreakdown": {
      "source": "Source",
      "title": "Nutritional breakdown"
    },
    "ownershipModal": {
      "description": "Choose an appropriate author to which you want to reassign the ingredient. After you change the author to Philips you cannot change it back.",
      "title": "Change ingredient ownership"
    },
    "plural": "Ingredients",
    "reassignOwnership": {
      "button": "Change author"
    },
    "referencedInRecipes": {
      "label": "Referenced in recipes"
    },
    "replace": "Replace",
    "replaceWith": "Replace with ...",
    "requiresAtLeastOneConversion": {
      "long": "This ingredient does not have required conversion for selected unit.<br><br>Please convert at least one of these units to grams: {{ units }}.",
      "modalTitle": "Ingredient is missing some conversions",
      "short": "Missing conversion from {{ units }} to grams"
    },
    "saveChangesDialog": {
      "description": "Before continuing you need to save changes made to the ingredient.",
      "title": "Save changes?"
    },
    "singular": "Ingredient",
    "toastMessage": {
      "ownershipChanged": "Ingredient author changed",
      "saved": "Ingredient saved"
    },
    "translatable": {
      "label": "Translatable",
      "status": "Translatable status"
    },
    "translation": {
      "addNew": "Add new ingredient translation",
      "display": "Display",
      "edit": "Edit ingredient translation",
      "plural": "Plural",
      "singular": "Singular"
    },
    "translationConflict": {
      "message": "already has translation <span class=\"translation-highlight\">{{ name }}</span> in language <span class=\"translation-highlight\">{{ language }}</span>.",
      "title": "Existing translations"
    },
    "unitConversion": {
      "add": "Add unit conversion",
      "approveModalDescription": "You are about to approve specific unit conversion of this ingredient. Please enter your approval reason:",
      "approveModalTitle": "Approve specific unit conversion",
      "approved": "Specific unit conversions are approved.",
      "conversionAmount": "Conversion amount",
      "deleteModalTitle": "Deleting unit conversion",
      "destinationAmount": "Amount ({{ unit }})",
      "destinationAmountPlaceholder": "Enter conversion amount",
      "edit": "Edit unit conversion",
      "history": {
        "approved": "Approved Specific unit conversions.",
        "unapproved": "Unapproved Specific unit conversions."
      },
      "missing": {
        "description": "There is no unit conversion information for this ingredient. Go to edit screen to add it.",
        "title": "Specific units conversion not available"
      },
      "noConversions": "There are no unit conversions for this ingredient",
      "notApproved": "Specific unit conversions are not approved.",
      "sourceAmount": "Amount ({{ unit }})",
      "sourceAmountPlaceholder": "Enter source unit amount",
      "sourceUnit": "Source unit",
      "sourceUnitPlaceholder": "Select unit",
      "title": "Specific units conversion",
      "unapproveModalDescription": "You are about to unapprove specific unit conversion of this ingredient. Please enter your unapproval reason:",
      "unapproveModalTitle": "Unapprove specific unit conversion"
    },
    "view": "View ingredient"
  },
  "ingredientUnit": {
    "bag": {
      "empty": "bags",
      "plural": "bags",
      "singular": "bag"
    },
    "branch": {
      "empty": "branches",
      "plural": "branches",
      "singular": "branch"
    },
    "bunch": {
      "empty": "bunches",
      "plural": "bunches",
      "singular": "bunch"
    },
    "can": {
      "empty": "cans",
      "plural": "cans",
      "singular": "can"
    },
    "centiliter": {
      "empty": "centiliters",
      "plural": "centiliters",
      "singular": "centiliter"
    },
    "clove": {
      "empty": "cloves",
      "plural": "cloves",
      "singular": "clove"
    },
    "cup": {
      "empty": "cups",
      "plural": "cups",
      "singular": "cup"
    },
    "dash": {
      "empty": "dashes",
      "plural": "dashes",
      "singular": "dash"
    },
    "decigram": {
      "empty": "decigram",
      "plural": "decigram",
      "singular": "decigram"
    },
    "deciliter": {
      "empty": "deciliters",
      "plural": "deciliters",
      "singular": "deciliter"
    },
    "drop": {
      "empty": "drops",
      "plural": "drops",
      "singular": "drop"
    },
    "fluidOunce": {
      "empty": "fluid ounces",
      "plural": "fluid ounces",
      "singular": "fluid ounce"
    },
    "gram": {
      "empty": "grams",
      "plural": "grams",
      "singular": "gram"
    },
    "kilogram": {
      "empty": "kilograms",
      "plural": "kilograms",
      "singular": "kilogram"
    },
    "liter": {
      "empty": "liters",
      "plural": "liters",
      "singular": "liter"
    },
    "microgram": {
      "empty": "micrograms",
      "plural": "micrograms",
      "singular": "microgram"
    },
    "milligram": {
      "empty": "milligrams",
      "plural": "milligrams",
      "singular": "milligram"
    },
    "milliliter": {
      "empty": "milliliters",
      "plural": "milliliters",
      "singular": "milliliter"
    },
    "ounce": {
      "empty": "ounces",
      "plural": "ounces",
      "singular": "ounce"
    },
    "package": {
      "plural": "packages",
      "singular": "package"
    },
    "piece": {
      "empty": "pieces",
      "plural": "pieces",
      "singular": "piece"
    },
    "pinch": {
      "empty": "pinches",
      "plural": "pinches",
      "singular": "pinch"
    },
    "pound": {
      "empty": "pounds",
      "plural": "pounds",
      "singular": "pound"
    },
    "sachet": {
      "empty": "sachet",
      "plural": "sachet",
      "singular": "sachet"
    },
    "scoop": {
      "empty": "scoops",
      "plural": "scoops",
      "singular": "scoop"
    },
    "shot": {
      "empty": "shots",
      "plural": "shots",
      "singular": "shot"
    },
    "slice": {
      "empty": "slices",
      "plural": "slices",
      "singular": "slice"
    },
    "stick": {
      "empty": "sticks",
      "plural": "sticks",
      "singular": "stick"
    },
    "tablespoon": {
      "empty": "tablespoons",
      "plural": "tablespoons",
      "singular": "tablespoon"
    },
    "teaspoon": {
      "empty": "teaspoons",
      "plural": "teaspoons",
      "singular": "teaspoon"
    }
  },
  "ingredients": {
    "recipes": {
      "emtpyState": "There are no recipes for this ingredient"
    }
  },
  "ingredinet": {
    "action": {
      "plural": "Actions"
    }
  },
  "invalidEmail": {
    "errorMessage": "Invalid e-mail address"
  },
  "invalidIdsDialog": {
    "description": "As following ID inputs don’t match or don’t exist in the system they can not be shown in the preview list. Review the entered ID list and remove wrong IDs in order to succesfully save the list.",
    "title": "Wrong ID input",
    "wrongIdsSubtitle": "Wrong ID inputs"
  },
  "jobStatus": {
    "completed": "Translations are created successfully.",
    "completedWithError": "AI translation creation has been partially successful.",
    "failed": "AI translation creation has failed.",
    "importing": "Importing of translated translations is in progress.",
    "pending": "AI translation process has started, translations are being processed, and will soon be sent to the AWS translation service for translating.",
    "readyForImport": "Translation process has finished, and translations are being imported into the system.",
    "submitted": "Translations are exported and sent to the AWS translation service for translating."
  },
  "labels": {
    "searchInputPlaceholder": "Search recipe books"
  },
  "landingPage": {
    "goToChangelogButton": "See what's new",
    "title": "Welcome to AdminUI"
  },
  "language": {
    "choose": "Choose language",
    "delete": "Delete language",
    "singular": "Language"
  },
  "limitExceededDialog": {
    "description": "The max number of items that you can export is",
    "title": "Limit exceeded"
  },
  "link": {
    "plural": "links"
  },
  "login": {
    "password": "Password",
    "username": "Username"
  },
  "macronutrients": {
    "title": "Macronutrients"
  },
  "menu": {
    "aiTranslations": "AI translation tasks",
    "create": {
      "accessory": "Create accessory",
      "announcement": "Create announcement",
      "article": "Create article",
      "articleCollection": "Create an article collection",
      "campaign": "Create a campaign",
      "collection": "Create a recipe book",
      "countdowns": "Create a countdown",
      "device": "Create device",
      "easyRecipeBook": "Create an easy recipe book",
      "highlights": "Create highlight",
      "ingredient": "Create ingredient",
      "onboardingAnnouncement": "Create onboarding announcement",
      "pinnedCollection": "Create a pinned recipe book",
      "pinnedRecipeBook": "Create a pinned recipe book",
      "plan": "Create a message plan",
      "productRecipeList": "Create a product recipe list",
      "promoCode": "Create a promo code",
      "pushMessage": "Create push notification",
      "recipe": "Create a recipe",
      "recipeBookCarousel": "Create a recipe book carousel",
      "recipeBookPack": "Create a recipe book pack",
      "recipeCarousel": "Create a recipe carousel",
      "shopAnnouncement": "Create shop announcement",
      "survey": "Create a poll",
      "user": "Create user",
      "video": "Create video"
    },
    "createVideo": {
      "digitalAssetManagement": "Upload a video"
    },
    "customTables": {
      "create": "Create a custom table"
    },
    "header": {
      "adminUiUsers": "Admin UI users",
      "announcements": "Announcements",
      "articleCollections": "Article collections",
      "articles": "Articles",
      "bulkManagement": "Translations & bulk actions",
      "campaigns": "Campaigns",
      "collections": "Recipe books",
      "comments": "Comments",
      "consumers": "Consumer list",
      "contentPublishing": "Content publishing",
      "contentScheduler": "Content scheduler",
      "countdowns": "Countdowns",
      "countries": "Countries",
      "countryAdministration": "Country administration",
      "customTables": "Custom tables",
      "dashboard": "Dashboard",
      "digitalAssetManagement": "Digital asset management",
      "highlights": "Highlights",
      "homeScreenCarousels": "Home Screen carousels",
      "ingredients": "Ingredients",
      "onboardingAnnouncements": "Onboarding announcements",
      "packs": "Packs",
      "plannedMessages": "Personalized messaging system",
      "productRanges": "Product ranges",
      "productRecipeLists": "Product recipe lists",
      "promoCodes": "Promo codes",
      "pushMessages": "Push notifications",
      "recipes": "Recipes",
      "reportedContent": "Reported content",
      "shopAnnouncements": "Shop announcements",
      "surveys": "Polls",
      "userAdministration": "User administration",
      "videos": "Videos",
      "recipeImages": "Recipe images"
    },
    "import": {
      "translations": "Import translations"
    },
    "subtitle": {
      "administration": "Administration",
      "appHomeScreen": "APP HOME SCREEN",
      "communityManagement": "COMMUNITY MANAGEMENT",
      "contentManagement": "Content management",
      "eCommerce": "E-commerce",
      "publishing": "PUBLISHING"
    },
    "unassignedProducts": "Unassigned products"
  },
  "metrics": {
    "numberOfArticles": "Number of articles",
    "numberOfCountries": "Number of countries",
    "numberOfDevices": "Number of devices",
    "numberOfExternalUsers": "Users from home.id portal: {{ count }}",
    "numberOfLinkedProducts": "Number of linked products",
    "numberOfRecipes": "Number of recipes",
    "numberOfTranslations": "Number of translations",
    "numberOfUsers": "Number of users"
  },
  "milliliter": {
    "abbreviation": "ml"
  },
  "mimeType": {
    "xml": "XML",
    "zip": "ZIP"
  },
  "mineral": {
    "calcium": "Calcium",
    "iron": "Iron",
    "magnesium": "Magnesium",
    "potassium": "Potassium",
    "salt": "Salt",
    "selenium": "Selenium",
    "sodium": "Sodium",
    "title": "Minerals",
    "zinc": "Zinc"
  },
  "minute": {
    "abbrv": {
      "plural": "mins"
    }
  },
  "missingInformationDialog": {
    "defaultErrorMessage": "Some of the fields are not valid, please edit them.",
    "editFollowingInformation": "Please edit the following information:",
    "moveToDraftMessage": "Please move the {{ contentType}} to Draft status and edit missing information.",
    "title": "Please fill missing information"
  },
  "modal": {
    "areYouSure": "Are you sure?",
    "pleaseSelectReason": "Please select the reason:"
  },
  "noCountryProfile": "No country profile",
  "notFound": {
    "description": "Page you entered doesn't exist.",
    "title": "Not found"
  },
  "nutrient": {
    "alcohol": "Alcohol",
    "calories": "Calories",
    "carbohydrates": "Carbohydrates",
    "cholesterol": "Cholesterol",
    "dietaryFibers": "Dietary fibers",
    "fat": "Fat",
    "macronutrients": "Macronutrients",
    "omega3FattyAcids": "Omega-3 fatty acids",
    "organicAcids": "Organic acids",
    "protein": "Protein",
    "saturatedFat": "Saturated fat",
    "sugar": "Sugar",
    "unsaturatedFattyAcids": "Unsaturated fatty acids",
    "water": "Water"
  },
  "nutrientTable": {
    "amount": "Amount",
    "nrv": "% NRV*",
    "per100g": "Per 100 g",
    "per100ml": "Per 100 ml"
  },
  "nutrientUnits": {
    "gram": "g",
    "kcal": "kcal",
    "microgram": "μg",
    "miligram": "mg"
  },
  "nutritionClaim": {
    "plural": "Nutrition claims",
    "singular": "Nutrition claim"
  },
  "onboardingAnnouncement": {
    "browse": {
      "title": "Browse onboarding announcements"
    }
  },
  "pagination": {
    "next": "Next",
    "previous": "Previous"
  },
  "pan": {
    "bottom": "Bottom pan",
    "combined": "Combined",
    "left": "Left pan",
    "right": "Right pan",
    "top": "Top pan",
    "xxlPan": "XXL Pan"
  },
  "pinnedCollection": {
    "activation": {
      "contentWillBeDeactivated": "<div>You are activating pinned recipe book for {{ country }}, therefore, {{ collectionBundlesForDeactivation }} will be deactivated.</div>",
      "missingPublishedRecipeBook": "Linked recipe book must have equal appliances, be in live status and published in this country."
    },
    "addBasicInformation": "Add basic information",
    "details": "Pinned recipe book details",
    "enterTitle": "Pinned recipe book title",
    "pinCollection": "Pin a recipe book",
    "saveThePinnedCollection": "Save the pinned recipe book?",
    "title": "Pinned recipe book title",
    "toastMessage": {
      "saved": "Pinned recipe book saved"
    },
    "validation": {
      "notSuitableForCountry": "Pinned recipe book is not published to the country"
    },
    "wantToSaveBeforeLeaving": "You are about to leave this screen and discard the pinned recipe book information you entered. Do you want to save the pinned recipe book to continue editing later?"
  },
  "pinningModal": {
    "conflicts": {
      "description": "You have selected countries that already contain a pinned {{ contentType }}. If you proceed with the pinning action of the current {{ contentType }}, already pinned {{ contentType }} will be unpinned first in each selected country with a conflict.",
      "title": "There are pinned publication conflicts with selected countries."
    },
    "description": "Select countries where you want to pin this {{ contentType }} in. You can only select countries, where this {{ contentType }} is already published. Only one {{ contentType }} can be pinned in a country at a time. Conflicts will be listed under the dropdown field.",
    "selectPlaceholder": "Choose countries",
    "title": "Changing pinned status of {{ contentType }}"
  },
  "placeholder": {
    "add": {
      "buttonText": "Add button text",
      "description": "Add description",
      "title": "Add title"
    },
    "choose": {
      "filter": "Choose {{ filter }}",
      "measurement": "Choose measurement"
    },
    "enter": {
      "amount": "Enter amount",
      "collectionName": "Enter recipe book name",
      "ingredientName": "Enter ingredient name",
      "ingredientNamePlural": "Enter ingredient name plural",
      "ingredientNameSingular": "Enter ingredient name singular",
      "measurement": "Enter measurement",
      "minutes": "Enter minutes",
      "seconds": "Enter seconds"
    }
  },
  "plannedMessages": {
    "addRulesetModal": {
      "formType": {
        "label": "Form type",
        "title": "Choose a type of form you want to create"
      },
      "reducer": {
        "label": "Operator",
        "title": "Choose how you want to connect the rules"
      },
      "required": "All fields must be selected.",
      "rule": {
        "label": "Rule selection",
        "placeholder": "Choose a rule"
      },
      "rulesetName": {
        "label": "Ruleset name",
        "placeholder": "Enter ruleset name"
      }
    },
    "createPlan": "Create a message plan",
    "editPlan": "Edit the message plan",
    "enterPlanTitle": "Enter plan title",
    "message": {
      "addNew": "Add new message",
      "label": "Message",
      "linkToArticleLabel": "Link to article",
      "locationType": "Location type",
      "messageWillBeLostWarning": "The delivery type is not selected. This message will be lost once the browser tab is closed. ",
      "placeholder": "Enter message here"
    },
    "messageGroup": {
      "addNew": "Add new message group",
      "label": "Message group"
    },
    "noRulesetApplied": {
      "add": "Add a rule/ruleset",
      "description": "There is no ruleset applied to this group",
      "title": "No ruleset applied"
    },
    "note": {
      "label": "Note",
      "placeholder": "Enter note"
    },
    "plan": {
      "activateModal": {
        "content": "Are you sure you want to change this plan's status?",
        "title": "Change plan status"
      },
      "button": {
        "activatePlan": "Activate plan",
        "deactivatePlan": "Deactivate plan"
      },
      "deleteModal": {
        "content": "Are you sure you want to delete this plan?",
        "title": "Delete plan"
      },
      "messageSection": {
        "title": "Message plan details"
      },
      "noPlans": "There are no plans",
      "note": {
        "label": "Note"
      },
      "planId": {
        "label": "Message plan ID"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive",
        "label": "Status"
      },
      "view": {
        "rulesetsTitle": "Rulesets & message groups"
      }
    },
    "planAction": {
      "addNew": "Add new message group rule",
      "category": {
        "label": "Category",
        "notFound": "Action category not found",
        "placeholder": "Choose a category",
        "required": "Action category is required"
      },
      "deleteModal": {
        "content": "Deleting this message group rule will remove all the nested messages group rules and their messages. Are you sure you want to delete it?",
        "title": "Delete message group rule"
      },
      "label": "Message group rule",
      "name": {
        "placeholder": "Enter name",
        "required": "Action name is required."
      }
    },
    "planStepMessage": {
      "activateModal": {
        "content": "Are you sure you want to change this message's status?"
      },
      "deleteModal": {
        "content": "Are you sure you want to delete this message?",
        "title": "Delete message"
      },
      "statusModal": {
        "title": "Change message status"
      }
    },
    "rule": {
      "label": "Rule"
    },
    "ruleset": {
      "addNewRuleToRuleset": "Add a rule/ruleset",
      "collapse": "Collapse ruleset",
      "expand": "Expand ruleset",
      "label": "Ruleset",
      "removeRule": {
        "description": "Are you sure you want to remove the rule?",
        "title": "Rule removing"
      },
      "removeRuleset": {
        "description": "Are you sure you want to remove the ruleset?",
        "title": "Ruleset removing"
      }
    },
    "tableHeaderTitle": "Name",
    "validation": {
      "title": {
        "required": "Plan title is required"
      }
    }
  },
  "preparedMeal": {
    "action": {
      "deflag": "Deflag image",
      "delete": "Delete image"
    },
    "changeStatus": {
      "deflag": {
        "content": "You are about to deflag this recipe image. Please enter your reason:",
        "title": "Deflagging image"
      }
    },
    "deflaggedToastMessage": "Image successfully deflagged.",
    "delete": {
      "content": "You are about to delete this recipe image. Please enter your reason:",
      "title": "Deleting image"
    },
    "inRecipe": "In recipe",
    "title": "Image from {{ owner }}"
  },
  "processingStep": {
    "addNewStep": "Add new step",
    "addStep": "Add step",
    "durationWarning": "Processing time must be between {{ min }} and {{ max }}",
    "editStep": "Edit step",
    "enterStepDescription": "Enter step description",
    "enterStepTitle": "Enter step title",
    "errorMessage": {
      "description": "All steps must have a description",
      "title": "Step must have a title"
    },
    "header": {
      "description": "Description",
      "photo": "Photo",
      "stepType": "Step type",
      "time": "Time",
      "title": "Step title",
      "video": "DAM Video"
    },
    "processingTime": "Processing time",
    "saveStep": "Save step",
    "step": "Step {{stepNumber}}",
    "stepDescription": "Step description",
    "stepTypePlaceholder": "Choose step type",
    "temperatureWarning": "Temperature must be between {{ min }}°C and {{ max }}°C",
    "uploadStepImage": "Upload step image"
  },
  "product": {
    "accessoryAvailabilityLabel": "Accessory is available in the same countries as the device they’re linked to.",
    "articles": "Product articles",
    "assetIdentifierEcommerceModel": "CTN from the E-commerce model field: {{ ctn }}",
    "assetIdentifierVariantCtn": "CTN from variant: {{ ctn }}",
    "brandNotDefined": "Product brands are not defined for: {{ countries }}. Without defined product brand for a country, device cannot be activated in that country.",
    "brands": "Product brands",
    "devicePresets": "Device presets",
    "errors": {
      "noVariants": "At least one Product variant is required."
    },
    "faqDialogDescription": "Product FAQ URLs may vary based on country, language, and product variant. Here is a list of all possible country language variant combinations and their FAQ, for all countries where the product is activated.",
    "linkedProducts": "Linked products",
    "manualsDialogDescription": "Product manual URLs may vary based on country and language. Here is a list of all possible country language combinations and their product manual URLs, for all countries where the product is activated.",
    "model": "Model",
    "noArticles": "Product is not used in any article.",
    "noArticlesFound": "No articles found for this country/language combination",
    "noDevicePresets": "No device presets",
    "noFaqFound": "No FAQs were found for the device as the device is not active in any country.",
    "noLinkedProducts": "Product has no linked products.",
    "noManualFound": "No user manual found for this country/language combination",
    "noManualsFound": "No manuals were found for the device as the device is not active in any country.",
    "noRecipes": "Product is not used in any recipe.",
    "noTroubleshootingFound": "No troubleshooting articles were found for the device as the device is not active in any country.",
    "noVariants": "Product has no variants.",
    "notActivatedOnHomeId": "Product is not activated on the home.id platform for this country",
    "notAvailableInAnyCountry": "Product is not available in any country.",
    "presetChildren": "Child presets",
    "presetCookingMethodCategory": "Cooking method",
    "properties": {
      "add": "Add product property",
      "empty": "There are no product properties.",
      "title": "Product properties"
    },
    "range": "Range",
    "recipes": "Product recipes",
    "representativeVpdbCtn": {
      "info": "Used for fetching product information from VPDB. It should not contain a wildcard (X), but the exact CTN.",
      "label": "Representative VPDB CTN"
    },
    "selectAssetIdentifierDescription": "Select exact device CTN for which you want to check the assets",
    "selectAssetIdentifierTitle": "Select device CTN",
    "status": {
      "draft": "Draft",
      "verified": "Verified"
    },
    "translations": "Product translations",
    "troubleshootingArticlesDialogDescription": "Product troubleshooting articles URLs may vary based on country, language, and product variant. Here is a list of all possible country language variant combinations and their troubleshooting articles, for all countries where the product is activated.",
    "variants": "Product variants",
    "variantsAndAvailabilities": "Product variants and availabilities"
  },
  "productBasicForm": {
    "preselectedAccessories": {
      "info": "Only standalone accessories can be chosen as preselected accessories."
    }
  },
  "productBrandsDialog": {
    "description": "Assign product brands to countries where you want to activate the product. A product cannot be activated in a country unless a brand is assigned to it for that specific country.",
    "multipleCountriesWithSameBrand": "Multiple brands are selected for: {{ item }}. Each country can only be assigned to one brand.",
    "title": "Update product brands"
  },
  "productRange": {
    "devices": {
      "emptyState": "There are no devices added to this product range yet",
      "noResults": "No results found for",
      "removalDescription": "After you remove this device, it will no longer be tied to the product range, which will affect the visibility of recipes made with this product range for users who use this device. Are you sure you want to remove the device?",
      "removalTitle": "Remove from the product range",
      "searchPlaceholder": "Search by name or model",
      "searchTitle": "Add devices to the product range",
      "selectedSearchPlaceholder": "Search added devices",
      "selectedTitle": "Added devices to the product range",
      "error": {
        "title": "Device is source product",
        "description": "The selected device is used in some recipes. It cannot be added to / removed from the product range until it is removed from all recipes."
      }
    },
    "devicesInRange": "Devices in the product range",
    "noDevicesInRange": "No devices are tied to this product range",
    "recipes": {
      "header": "Recipes with this product range",
      "noItems": "There are no recipes made with this product range"
    }
  },
  "publicationModal": {
    "alreadyActivatedInCountry": "Already activated in country.",
    "alreadyPublishedInCountry": "Already published in country.",
    "anotherPushMessageAlreadyScheduledInTimeframe": "Push message {{ scheduledEvents }} is already scheduled in the timeframe of {{ timeframe }} hours before or after the event.",
    "anotherPushMessageAlreadySentInTimeframe": "Push message {{ pushMessages }} was already sent in the last {{ timeframe }} hours.",
    "approvedTranslationsLabel": "Approved translations: {{ languages }}.",
    "contentAlreadyScheduled": "Content is already scheduled.",
    "contentNotManaged": "Scheduling is not allowed because linked content belongs to the consumer. Only content managed by Philips can be scheduled.",
    "countryAlreadyHasActiveEasyRecipeBook": "Already activated {{ activePackName }} will be automatically deactivated in this country.",
    "countryHasActiveCampaign": "Already activated {{ activeCampaignName }} will be automatically deactivated in this country.",
    "countryHasActivePackHolder": "Already activated {{ activePackName }} will be automatically deactivated in this country.",
    "countryHasActiveVotingSurvey": "Country already has activated survey.",
    "linkedContentNotPublished": "Linked content is not published to country.",
    "linkedContentNotScheduledOrPublished": "Linked content is not published or scheduled for publishing. Linked content should be published or scheduled before publishing.",
    "linkedProfileDoesNotBelongToCountry": "Linked profile does not belong to country.",
    "missingApprovedTranslations": "Translation for {{ country }} is not approved or does not exist.",
    "missingApprovedTranslationsLabel": "Unapproved or missing translations: {{ languages }}.",
    "missingIngredientTranslation": "Some ingredients are missing translations: {{ missingTranslations }}",
    "missingOneApprovedTranslation": "Missing at least one approved translation.",
    "missingPublishedHighlights": "At least {{ minHighlights }} highlights must be published to the country.",
    "missingPublishedRecipes": "{{ publishedRecipes }}/{{ totalRecipes }} recipes have been published in the country. Recipes that are not published will not be visible.",
    "missingRecipeLiveTranslationsForCountry": "One or more linked recipes are missing translations.",
    "noneOfDevicesSupportVoltage": "None of the devices from the recipe support {{ electricSystem }} electric system.",
    "notLive": "Content is not in live status.",
    "pushMessageAlreadySent": "Push notification has already been sent.",
    "recipeWithSameTitleAlreadyPublishedInCountry": "Recipes with the same name already exist in the country: {{ shortContentId }}"
  },
  "publishContentDialog": {
    "subtitle": "Select a country profile to which you wish to publish the selected content list. Please enter your reason:"
  },
  "pushMessage": {
    "appliance": {
      "required": "Appliance is required"
    },
    "deliveries": {
      "delivered": {
        "label": "Sent"
      },
      "error": {
        "label": "Failed"
      },
      "pending": {
        "label": "Pending"
      },
      "sentLanguages": "Sent {{ sentNumber }}/{{ totalNumber }} languages",
      "skipped": {
        "label": "Skipped"
      }
    },
    "description": {
      "placeholder": "Enter push notification description",
      "required": "Push notification description is required"
    },
    "details": "Push notification details",
    "errors": {
      "delete": {
        "title": "Error while deleting the push notification"
      },
      "generic": {
        "description": "Error is displayed in the console. Please contact developers.",
        "title": "Error while saving the push notification"
      },
      "send": {
        "title": "Error while sending the push notification"
      }
    },
    "form": {
      "create": "Create push notification",
      "edit": "Edit push notification"
    },
    "saveTheAnnouncement": "Save the announcement?",
    "saveThePushMessage": "Save the push notification?",
    "section": {
      "content": {
        "title": "Add push notification content"
      }
    },
    "sendModal": {
      "description": "You will send a push notification to {{ appliance }} in {{ countries }}. Please, take into account that it is possible that push notification will not be sent immediately due to technical limitation.",
      "title": "Send push notification?"
    },
    "title": {
      "placeholder": "Enter push notification title",
      "required": "Push notification title is required"
    },
    "toastMessage": {
      "delete": "The push notification has been deleted",
      "saved": "Push notification saved"
    },
    "translationErrors": {
      "descriptionRequired": "Push notification description is required",
      "titleRequired": "Push notification title is required"
    },
    "type": {
      "announcement": "Announcement",
      "article": "Article",
      "general": "General",
      "label": "Type",
      "placeholder": "Choose type",
      "recipe": "Recipe",
      "recipeBook": "Recipe book",
      "required": "Type is required"
    },
    "view": "View push notification"
  },
  "pushMessages": {
    "browse": {
      "title": "Browse push notifications"
    }
  },
  "qualityIndicator": {
    "calorieDifference": "There is a significant difference in kcal values between the databases. Please check.",
    "fat": "fat",
    "group": {
      "fatProteinSodium": "This recipe is high in {{ indicatorsList }}. Please check."
    },
    "hover": {
      "fat": "The amount of fat is higher than {{ limit }} per serving",
      "protein": "The amount of protein is higher than {{ limit }} per serving",
      "sodium": "The amount of sodium is higher than {{ limit }} per serving"
    },
    "protein": "protein",
    "sodium": "sodium"
  },
  "recipe": {
    "activePreparation": {
      "errorMessage": "Active preparation time is required",
      "label": "Active preparation",
      "placeholder": "Enter active preparation time",
      "positiveNumberErrorMessage": "Preparation time must be a positive number.",
      "tooltip": "Time spent washing, slicing, and dicing ingredients"
    },
    "activeTime": {
      "label": "Active time",
      "tooltip": "Processing time + Active preparation"
    },
    "addToCollection": {
      "content": "A recipe can only be added to the DRAFT and APPROVED recipe books",
      "recipeAlreadyInCollection": "Recipe is already in recipe book \"{{ collectionName }}\"",
      "saveButtonLabel": "Add recipe",
      "successMessage": "Recipe added to recipe book \"{{ collectionName }}\"",
      "title": "Add recipe “{{ title }}” to a recipe book"
    },
    "article": {
      "notUsed": "Recipe is not being used in any article."
    },
    "blenderTotalTime": {
      "tooltip": "Active + Passive preparation"
    },
    "chageDomainToGlobal": {
      "dialog": {
        "descriptionUs": "Source language translation will be changed to English. Please, correct translations if needed.",
        "saveButton": "Yes, move to GLOBAL",
        "title": "Are you sure you want to change your local domain to GLOBAL?"
      },
      "toastMessage": "Recipe domain successfully changed to GLOBAL"
    },
    "changeOrganizationConfirmation": {
      "description": "Ingredient amounts and recipe step source product temperatures will be reset. Are you sure?",
      "title": "Change organization"
    },
    "changeStatus": {
      "delete": {
        "content": "Please select the reason (the reason will be visible to consumer):",
        "title": "Recipe deletion"
      }
    },
    "cookTime": {
      "errorMessage": "Total processing time cannot be greater than {{ minutes }} minutes"
    },
    "create": "Create {{device}} recipe",
    "details": "Recipe details",
    "downloadSuccessMessage": "The recipe is downloaded.",
    "edit": "Edit {{device}} recipe",
    "errorMessage": {
      "numberOfServings": {
        "max": "Number of servings must be between {{ min }} and {{ max }}",
        "min": "Number of servings must be greater than {{ min }}"
      }
    },
    "errors": {
      "coverImage": {
        "required": "Recipe must have cover image."
      },
      "imageRequired": "Image is required"
    },
    "export": "Recipe export",
    "exportRecipe": "Export recipe",
    "exportRecipeTooltip": "Export and download recipe in the .XML format",
    "form": {
      "create": "Create recipe",
      "edit": "Edit recipe"
    },
    "id": "Recipe ID",
    "import": "Import recipe",
    "importDescription": "Click select file or drag and drop your ZIP file",
    "ingredient": {
      "delete": {
        "content": "Are you sure you want to delete the ingredient?",
        "title": "Delete ingredient"
      }
    },
    "ingredientPriority": {
      "main": "Main",
      "regular": "Regular"
    },
    "ingredients": {
      "migration": {
        "button": "Migrate ingredients",
        "cancelModal": {
          "description": "Are you sure you wish to discard the ingredient migration?",
          "title": "Cancel ingredient migration"
        },
        "confirmationModal": {
          "description": "Do you wish to confirm the migration of ingredients to steps?<br/><br/>Please note that after this migration, undo will not be possible. Ingredient editing will be available through the steps section. Any ingredients not assigned to a step when the recipe is saved will be deleted.",
          "title": "Confirm ingredient migration"
        },
        "message": "You need to migrate all ingredients to recipe steps section to enable editing.",
        "modal": {
          "subtitle": "Please assign the ingredients to the corresponding steps",
          "title": "Ingredients migration",
          "unitMismatchNotice": "Highlighted ingredients will not be migrated due to unit incompatibilities. The same ingredients with differing unit values will need to be added manually after the migration."
        },
        "nonMigratedIngredients": {
          "description": "Not all ingredients from your recipe have been fully migrated to the steps. Ingredients that remain unmigrated will be permanently deleted from the recipe if you proceed.<br/><br/>Do you want to proceed with saving the changes?",
          "title": "Some ingredients have not been migrated."
        },
        "suggestions": {
          "message": "We have attempted to automatically assign steps to ingredients based on their mention in the step descriptions. Please review the result and adjust accordingly before confirming the migration.",
          "title": "Auto-assigned steps"
        },
        "title": "Update is required"
      }
    },
    "maxNumberOfServings": {
      "label": "Maximum servings"
    },
    "missingDialogOptions": {
      "question": "Do you want to edit the recipe now?"
    },
    "missingIncompatibleDevicesDialog": {
      "description": "The recipe does not have {{ deviceNames }} in the product range. To display a device incompatibility message on a mobile device please add the device to the incompatible devices field.",
      "proceedLabel": "Ignore warning and save",
      "title": "Incompatible device detected"
    },
    "moveToGlobal": "Change domain of a recipe to GLOBAL",
    "noIngredients": "Recipe doesn't have any ingredients.\n",
    "noProcessingSteps": "Recipe doesn't have any steps.",
    "noTags": "Recipe doesn't have any tags.",
    "numberOfServings": {
      "label": "Number of Servings",
      "placeholder": "Enter number of servings"
    },
    "nutriInfoCalculation": {
      "beingRecalculated": "Nutritional information is currently being recalculated.",
      "canNotBeCalculated": "Main ingredients can't be calculated. Please check if any data mappings or conversions are missing.",
      "cannotBeDone": "Nutritional information cannot be calculated due to missing information.",
      "inAFewMinutes": "Nutritional information will be available in a few minutes.",
      "pleaseCheck": "Please check if any data mappings or conversions are missing.",
      "willBeAvailableSoon": "Information will be available soon."
    },
    "nutritionalInformation": {
      "breakdown": {
        "caloriesBreakdownGraphTitle": "Calories breakdown",
        "hide": "Hide breakdown",
        "show": "Show breakdown"
      },
      "countrySelectionLabel": "Display nutritional information for",
      "disclaimer": {
        "amountPerServing": "Amounts are per serving. <strong>One serving is 1/{{ numberOfServings }} of “{{ recipeTitle }}” recipe</strong>.",
        "dailyValues": "* Nutrient reference value is based on a {{ baseCalories }} kcal diet. Your daily values may be higher or lower depending on your calorie needs.",
        "numerOfServings": "Each serving is<br>1/{{ numberOfServings }} recipe"
      },
      "kcal": "kcal",
      "perServing": "Per serving",
      "sectionTitle": "Nutritional information",
      "tab": {
        "energy": "Energy",
        "nutrients": "Nutrients"
      }
    },
    "passivePreparation": {
      "label": "Passive preparation",
      "placeholder": "Enter passive preparation time",
      "tooltip": "Time spent drying, soaking or freezing ingredients"
    },
    "preparedMeals": {
      "emptyState": "There are no images for selected country",
      "sectionTitle": "Recipe images by consumers"
    },
    "print": "Print",
    "printOrSaveAsPdf": "Print or download recipe as .PDF file",
    "processingTimeWithPressure": {
      "tooltip": "Includes build and release pressure time"
    },
    "reassignLanguage": {
      "description": "Choose a supported language of the recipe’s country.",
      "toastMessage": "Recipe language was changed to {{ language }}",
      "tooltip": "To reassign recipe language recipe must have more than one approved translation."
    },
    "recipePreparations": {
      "emptyState": "There are no images for this recipe",
      "hideButton": "Hide images",
      "showButton": "Show images",
      "title": "Recipe images by consumers"
    },
    "similarIngredientsDialog": {
      "description": "Looks like the recipe you want to save has very similar ingredients as the following recipes:",
      "title": "Ingredient combination detected"
    },
    "step": {
      "delete": {
        "content": "Are you sure you want to delete the step?",
        "title": "Delete step"
      }
    },
    "tag": {
      "difficulty": {
        "easyToStart": "Yes",
        "label": "Easy to start",
        "notEasyToStart": "No",
        "placeholder": "Easy to start"
      }
    },
    "titleConflict": {
      "explanation": "Please make sure you are not creating a duplicate recipe, as there is already one existing using the same name",
      "inLanguage": "in language"
    },
    "toastMessage": {
      "saved": "Recipe has been successfully saved",
      "translationSaved": "Recipe translation saved successfully."
    },
    "totalTime": {
      "errorMessage": "Total time must be greater than 0",
      "label": "Total time",
      "tooltip": "Processing time + Active preparation + Passive preparation"
    },
    "translations": {
      "export": {
        "includeNonTranslatable": "Include not translatable ingredients",
        "includeUserIngredients": "Include user ingredients",
        "noCommonLanguages": "Selected items don't have common languages."
      }
    },
    "unitSystem": {
      "label": "Unit system"
    },
    "view": "View recipe"
  },
  "recipeBookCarousel": {
    "addCollectionsToCarousel": "Add recipe books to the carousel (min.{{ minCollections }})",
    "addedCollectionsToCarousel": "Added recipe books to the carousel ({{ currentValue }})",
    "collections": {
      "emptyStateMessage": "There are no recipe books in this carousel."
    },
    "details": "Recipe book carousel details",
    "enterTitle": "Recipe book carousel title",
    "noRecipeBooksAddedToCarousel": "There are no recipe books added to this carousel.",
    "recipeBookRemovalDescription": "Are you sure you want to remove the recipe book from the carousel?",
    "recipeBookRemovalTitle": "Remove from carousel",
    "saveTheRecipeBookCarousel": "Do you want to save the changes before leaving?",
    "title": "Recipe book carousel title",
    "toastMessage": {
      "saved": "Recipe book carousel saved"
    },
    "wantToSaveBeforeLeaving": "You are about to leave this screen and discard the recipe book carousel information you entered. Do you want to save the recipe book carousel to continue editing later?"
  },
  "recipeCarousel": {
    "details": "Recipe carousel details",
    "enterTitle": "Recipe carousel title",
    "pinCollection": "Add a recipe book to carousel",
    "recipeBookAddTitle": "Add recipe books to the carousel",
    "recipeBookRemovalTitle": "Remove from carousel",
    "saveTheRecipeCarousel": "Save the recipe carousel?",
    "title": "Recipe carousel title",
    "toastMessage": {
      "saved": "Recipe carousel saved"
    },
    "wantToSaveBeforeLeaving": "You are about to leave this screen and discard the recipe carousel information you entered. Do you want to save the recipe carousel to continue editing later?"
  },
  "recipeDetails": {
    "commentsByConsumers": "Comments by consumers"
  },
  "recipeForm": {
    "coverImage": {
      "label": "Upload cover photo"
    },
    "nutritionalInformation": {
      "label": "Note",
      "placeholder": "Enter note"
    },
    "recipeType": {
      "ingredient": "Ingredient",
      "label": "Recipe type",
      "regular": "Regular"
    },
    "subtitle": {
      "basicInformation": "Add basic information",
      "ingredient": "Add ingredient",
      "nutritionalInformation": "Add nutritional information",
      "recipeType": "Recipe type",
      "servings": "Servings",
      "timeAndServings": "Time and servings"
    }
  },
  "recipeLock": {
    "title": "Another user is editing this recipe",
    "warning": "Recipe can't be edited. User {{ user }} is currently editing this recipe."
  },
  "recipePreparation": {
    "action": {
      "deflag": "Deflag image",
      "view": "View image"
    },
    "basicInformation": {
      "device": "Device",
      "inRecipe": "In recipe"
    },
    "title": "Image from {{ owner }}",
    "browse": {
      "all": "Browse recipe images"
    }
  },
  "recipeRepublish": {
    "missingApprovedTranslations": "Translation for {{label}} profile is not approved or does not exist.\n",
    "warningMessage": {
      "published": "This recipe is already published to this Country Profile. Do you want to republish it as a new recipe?",
      "unpublished": "This recipe was already published to this Country Profile. Do you want to publish it as a new recipe or republish it to its previous position?"
    }
  },
  "recipeStep": {
    "appliance": {
      "label": "Appliance",
      "placeholder": "Select appliance group",
      "required": "Please select the Domain first"
    },
    "device": {
      "label": "Source product",
      "placeholder": "Select source product"
    },
    "duration": {
      "label": "Duration",
      "placeholder": "0"
    },
    "errors": {
      "couldNotLoadParameters": "Could not load step parameters",
      "missingTranslation": "Missing recipe step translation"
    },
    "numberOfShakes": {
      "placeholder": "0"
    },
    "preparationStep": {
      "label": "Preparation"
    },
    "processingStep": {
      "label": "Processing"
    },
    "propagateChangesDialog": {
      "description": "Changes of source products and product ranges will be applied to all other processing steps",
      "title": "Save step"
    },
    "speed": {
      "label": "Speed",
      "placeholder": "0"
    },
    "temperature": {
      "label": "Temperature",
      "placeholder": "0"
    },
    "tools": {
      "placeholder": "Select tools"
    }
  },
  "recipeTranslations": {
    "clickSelectFileOrDragXmlOrZip": "Click select file or drag and drop your {{ fileTypes }} files",
    "keywords": {
      "label": "Keywords",
      "placeholder": "Add keywords"
    }
  },
  "recipeValidator": {
    "ingredientsBelowLimit": "Recipe has more than {{limit}} ingredients",
    "processingStep": {
      "preheatingOrderErrorMessage": "Please move the processing step with Preheat cooking method at least one place before the earliest processing step.",
      "preheatingOrderErrorTitle": "Error in recipe steps"
    },
    "requiredIngredient": "Recipe must have at least one ingredient",
    "requiredStep": "Recipe must have at least one step"
  },
  "recipes": {
    "exportTranslations": "Export translations"
  },
  "reloadPageDialog": {
    "button": {
      "proceed": "Refresh",
      "stop": "Ignore for 5 minutes"
    },
    "description": "The new version of the Admin UI application has been released. Please refresh the page to prevent unexpected issues.",
    "title": "New version available"
  },
  "reportReason": {
    "inappropriateLanguage": "Inappropriate language",
    "inappropriateOrAbusiveContent": "Inappropriate or abusive content",
    "incompleteContent": "Incomplete content",
    "incorrectContent": "Incorrect content",
    "other": "Other",
    "spam": "Spam"
  },
  "reportedContent": {
    "dialog": {
      "subtitle": "Please enter additional reason (this won't be visible to the consumer)",
      "takingOfflineReason": "Taking offline reason",
      "takingOfflineSubtitle": "Please enter additional reason"
    },
    "statusIndicatorLabel": "Unresolved reports"
  },
  "reportedContentHeader": {
    "numberOfActiveReports": "Number of active reports",
    "numberOfReports": "Number of reports"
  },
  "reportedContentStatus": {
    "inReview": "In review",
    "reported": "Reported",
    "reviewed": "Reviewed"
  },
  "reportedItems": {
    "searchPlaceholder": "Find the reported item by text or short ID"
  },
  "reportingInformation": {
    "authorType": {
      "philips": "Philips"
    },
    "commentedBy": "Commented by",
    "noReports": "No reports",
    "products": "consumer products",
    "reason": "Reason",
    "reportReason": "Report reason",
    "reportStatus": "Report status",
    "reportedAt": "Reported at",
    "reportedBy": "Reported by",
    "title": "Reporting information",
    "toastMessage": {
      "copyIDSuccess": "User ID copied to clipboard"
    }
  },
  "republishPosition": {
    "new": "New {{ contentType }}",
    "previous": "Previous position",
    "top": "New recipe"
  },
  "resourceType": {
    "collection": "Recipe book",
    "ingredient": "Ingredient",
    "recipe": "Recipe"
  },
  "richItemSelector": {
    "emptyStateLabel": "There are no items added.",
    "fetchDisabledLabel": "Please fill required information first",
    "itemRemovalDescription": "Are you sure you want to remove the item from the selected items?",
    "itemRemovalTitle": "Remove item",
    "noSearchResultsLabel": "No items found for",
    "searchInputPlaceholder": "Search items",
    "searchItemsTitle": "Add items",
    "selectedItemsSearchBarInputPlaceholder": "Search added items",
    "selectedItemsTitle": "Selected items ({{ selectedItemsCount }})"
  },
  "role": {
    "chef": "Chef",
    "communityManager": "Community manager",
    "contentManager": "Content manager",
    "globalContentManager": "Global content manager",
    "ingredientManager": "Ingredient manager",
    "nutritionist": "Nutritionist",
    "organization": {
      "errors": {
        "required": "Domain is required"
      }
    },
    "readOnlyAccess": "Read only access",
    "systemAdministrator": "System administrator"
  },
  "saveSearch": {
    "placeholder": "Enter search title",
    "title": "Enter the name of the saved search"
  },
  "savedFilters": {
    "clearFilters": "Clear filters",
    "selecteFilterSet": "Select saved filter set",
    "youDontHaveAnySets": "You don't have any saved filter sets",
    "youDontHaveAnySetsForDomain": "You don't have any saved filter sets for this domain"
  },
  "scheduledEvent": {
    "actions": {
      "saveUnpublishingChanges": "Save unpublishing changes"
    },
    "content": {
      "placeholder": "Search content"
    },
    "enterEventName": "Enter event name",
    "errors": {
      "eventName": {
        "required": "Event name is required"
      },
      "saving": "Scheduled event could not be saved",
      "scheduledAt": {
        "pastDate": "Publish at date must be in the future",
        "required": "Publish at date is required"
      },
      "scheduledEventType": {
        "required": "Type is required"
      },
      "unpublicationScheduledAt": {
        "pastDate": "Unpublish at date must be in the future",
        "publishingAfterUnpublishing": "Unpublishing date cannot be set before publishing."
      }
    },
    "name": "Event name",
    "publishAt": "Publish at",
    "scheduledUnpublishing": {
      "header": "Unpublish at",
      "toggleLabel": "I want to also schedule unpublishing.",
      "toggleTooltip": "When preparing scheduled events, you can also add scheduled content unpublishing. This will generate two connected items on the calendar. You can change the unpublishing date even after the publishing action of this event is done.",
      "warning": "Removing the unpublishing date will mark this event as \"finished\", and re-adding the unpublishing date will no longer be possible."
    },
    "status": {
      "event": "Event status",
      "publishing": "Publishing status",
      "unpublishing": "Unpublishing status"
    }
  },
  "scheduledEventType": {
    "maintenance": {
      "plural": "Maintenances",
      "singular": "Maintenance"
    }
  },
  "searchBar": {
    "deleteCustomFilterTitle": "Do you want to delete filter set \"{{ filterName }}\"?",
    "input": {
      "commentPlaceholder": "Search by comment text or content ID",
      "defaultPlaceholder": "What are you looking for?"
    }
  },
  "searchbar": {
    "clearFilters": "Clear",
    "saveSet": "Save set",
    "tab": {
      "all": "All",
      "allContent": "All content",
      "allCountries": "All countries",
      "allDomains": "All domains",
      "collections": "Recipe books",
      "comments": "Comments",
      "consumers": "Consumers",
      "preparedMeal": "Consumer images",
      "recipes": "Recipes"
    }
  },
  "selectLabel": {
    "self": "{{label}} (you)"
  },
  "sensitiveFieldChecks": {
    "announcement": {
      "translation": {
        "callToAction": "Changed announcement button text",
        "description": "Changed announcement description",
        "title": "Changed announcement title"
      }
    },
    "article": {
      "step": {
        "translation": {
          "description": "Changed article step description",
          "title": "Changed article step title"
        }
      },
      "steps": {
        "added": "Added new article step"
      },
      "translation": {
        "description": "Changed article description",
        "title": "Changed article title"
      }
    },
    "collection": {
      "translation": {
        "description": "Changed recipe book description",
        "title": "Changed recipe book title"
      }
    },
    "modal": {
      "details": "All Approved translations will be moved to Draft status. Translations need to be updated due to the following content changes:",
      "title": "Translations moved to Draft"
    },
    "recipe": {
      "ingredients": {
        "added": "Added new recipe ingredient",
        "changed": "Changed recipe ingredient(s)"
      },
      "steps": {
        "added": "Added new step",
        "changed": "Changed step(s) description"
      },
      "translation": {
        "description": "Changed recipe description",
        "keywords": "Changed recipe keywords",
        "title": "Changed recipe title"
      }
    },
    "survey": {
      "surveyItem": {
        "added": "Added new answer",
        "titleChanged": "Answer changed"
      },
      "translation": {
        "description": "Changed description",
        "title": "Changed title"
      }
    }
  },
  "sidebar": {
    "releaseNotes": "See what's new"
  },
  "spaceLink": {
    "error": {
      "url": "Enter a valid URL"
    },
    "type": {
      "amazonPrivacyPolicy": "Amazon privacy policy",
      "amazonProduct": "Amazon product",
      "amazonTermsAndConditions": "Amazon terms and conditions",
      "privacyPolicy": "Privacy policy",
      "supportContactDetails": "Support contact details",
      "termsAndConditions": "Terms and conditions"
    }
  },
  "ssoLandingPage": {
    "buttonText": "I want to login with my <strong>{{sso}}</strong> email",
    "cardTitle": "One step away from AdminUI!",
    "chooseProviderText": "Please choose the email domain you want to login with to proceed to AdminUI."
  },
  "status": {
    "approved": "Approved",
    "blocked": "Blocked",
    "created": "Created",
    "deleted": "Deleted",
    "deletedByCM": "Deleted by Content Manager",
    "deletedByConsumer": "Deleted by consumer",
    "draft": "Draft",
    "inReview": "In review",
    "live": "Live",
    "liveFlagged": "Live flagged",
    "quarantined": "Quarantined"
  },
  "stepFormExpandedDialog": {
    "description": "Please close any steps that you are still editing before saving the recipe",
    "title": "Editing step"
  },
  "storeCategory": {
    "allProducts": "All products",
    "singleProduct": "Single product"
  },
  "survey": {
    "description": {
      "label": "Description"
    },
    "endDateTime": {
      "label": "End time"
    },
    "errors": {
      "missingTranslation": "Missing answer translation"
    },
    "surveyItem": {
      "itemized": "Answer {{ itemNumber }}",
      "singular": "Poll answer"
    },
    "surveyItems": {
      "empty": "There are no answers for this poll",
      "minLengthError": "Survey has to have at least 2 answers",
      "title": "Poll answers"
    }
  },
  "table": {
    "header": {
      "action": "Action",
      "actions": "Actions",
      "announcementInfo": "Announcement info",
      "appliance": "Appliance",
      "articleInfo": "Article info",
      "articleType": "Article type",
      "category": "Category",
      "collectionInfo": "Recipe book info",
      "commentBy": "Comment by",
      "commentText": "Comment text",
      "contentInfo": "{{ contentType }} info",
      "countriesPublished": "Countries published",
      "dateAdded": "Date added",
      "dateCreated": "Date created",
      "datePosted": "Date posted",
      "domain": "Domain",
      "domainOrCountry": "Domain / Country",
      "highlightInfo": "Highlight info",
      "info": "Info",
      "like": "Like",
      "likeAction": "Like",
      "modified": "Last modified",
      "numberOfLikes": "No. of Likes",
      "nutritionInfo": "Nutrition info",
      "presetInfo": "Preset info",
      "published": "Published date",
      "recipeInfo": "Recipe info",
      "recipePreparations": "Recipe preparations",
      "recipes": "Recipes",
      "text": "Text",
      "title": "Title",
      "translations": "Translations",
      "type": "Type",
      "userType": "Owner type",
      "imageBy": "Image by"
    }
  },
  "tenantLogin": {
    "description": "Please select the application you want to continue to.",
    "title": "Start managing your content"
  },
  "timeRangeOptions": {
    "allTime": "All time",
    "lastDay": "Past 24 hours",
    "lastMonth": "Past month",
    "lastWeek": "Past week",
    "lastYear": "Past year"
  },
  "title": {
    "accessDenied": "Access denied",
    "accessoryCreate": "Create an accessory",
    "accessoryDetails": "Accessory details",
    "accessoryEdit": "Edit accessory",
    "administratorCreate": "Create an administrator",
    "administratorDetails": "Administrator details",
    "administratorEdit": "Edit administrator",
    "administratorList": "Browse administrators",
    "announcementCreate": "Create an announcement",
    "announcementDetails": "Announcement details",
    "announcementEdit": "Edit announcement",
    "announcementTranslations": "Announcement translations",
    "articleCollectionCreate": "Create an article collection",
    "articleCollectionDetails": "Article collection details",
    "articleCollectionEdit": "Edit article collection",
    "articleCollectionTranslations": "Article collection translations",
    "articleCreate": "Create an article",
    "articleDetails": "Article details",
    "articleEdit": "Edit article",
    "articleList": "Browse articles",
    "articleTranslations": "Article translations",
    "bulkActions": "Translations and content actions",
    "bulkAiTranslations": "AI translations",
    "bulkImportTranslations": "Import translations from files",
    "campaignCreate": "Create a campaign",
    "campaignDetails": "Campaign details",
    "campaignEdit": "Edit campaign",
    "campaignTranslations": "Campaign translations",
    "changelog": "Application changelog",
    "commentDetails": "Comment details",
    "commentList": "Browse comments",
    "consumerDetails": "View consumer details",
    "consumerList": "Browse consumers",
    "contentPublishing": "Content publishing",
    "countdownList": "Browse countdowns",
    "countryDetails": "Country details",
    "countryEdit": "Edit country",
    "countryList": "Browse countries",
    "customTableCreate": "Create a custom table",
    "customTableDetails": "Custom table details",
    "customTableEdit": "Edit custom table",
    "customTableList": "Browse custom tables",
    "dam": "Digital asset management",
    "deviceCreate": "Create a device",
    "deviceDetails": "Device details",
    "deviceEdit": "Edit device",
    "deviceHealth": "Device assets",
    "easyRecipeBookCreate": "Create an easy recipe book",
    "easyRecipeBookDetails": "Easy recipe book details",
    "easyRecipeBookEdit": "Edit easy recipe book",
    "easyRecipeBookTranslations": "Easy recipe book translations",
    "gettingStarted": "AdminUI documentation",
    "highlightCreate": "Create a highlight",
    "highlightDetails": "Highlight details",
    "highlightEdit": "Edit highlight",
    "highlightTranslations": "Highlight translations",
    "ingredientCreate": "Create an ingredient",
    "ingredientDetails": "Ingredient details",
    "ingredientEdit": "Edit ingredient",
    "ingredientList": "Browse ingredients",
    "ingredientTranslations": "Ingredient translations",
    "login": "Login to administrative portal",
    "onboardingAnnouncementCreate": "Create an onboarding announcement",
    "onboardingAnnouncementDetails": "Onboarding announcement details",
    "onboardingAnnouncementEdit": "Edit onboarding announcement",
    "onboardingAnnouncementTranslations": "Onboarding announcement translations",
    "productList": "Browse products",
    "productRangeDetails": "Product range details",
    "productRangeList": "Browse product ranges",
    "productRecipeListCreate": "Create a product recipe list",
    "productRecipeListDetails": "Product recipe list details",
    "productRecipeListEdit": "Edit product recipe list",
    "promoCodeCreate": "Create a promo code",
    "promoCodeDetails": "Promo code details",
    "promoCodeEdit": "Edit promo code",
    "promoCodeTranslations": "Promo code translations",
    "recipeBookCarouselCreate": "Create a recipe book carousel",
    "recipeBookCarouselDetails": "Recipe book carousel details",
    "recipeBookCarouselEdit": "Edit recipe book carousel",
    "recipeBookCarouselTranslations": "Recipe book carousel translations",
    "recipeBookCreate": "Create a recipe book",
    "recipeBookDetails": "Recipe book details",
    "recipeBookEdit": "Edit recipe book",
    "recipeBookTranslations": "Recipe book translations",
    "recipeCarouselCreate": "Create a recipe carousel",
    "recipeCarouselDetails": "Recipe carousel details",
    "recipeCarouselEdit": "Edit recipe carousel",
    "recipeCarouselTranslations": "Recipe carousel translations",
    "recipeCreate": "Create a recipe",
    "recipeDetails": "Recipe details",
    "recipeEdit": "Edit recipe",
    "recipeList": "Browse recipes",
    "recipeTranslations": "Recipe translations",
    "reportedContent": "Browse reported content",
    "scheduledEventCreate": "Create a scheduled event",
    "scheduledEventDetails": "Scheduled event details",
    "scheduledEventEdit": "Edit scheduled event",
    "scheduledEventList": "Content scheduler",
    "shopAnnouncementCreate": "Create a shop announcement",
    "shopAnnouncementDetails": "Shop announcement details",
    "shopAnnouncementEdit": "Edit shop announcement",
    "shopAnnouncementTranslations": "Shop announcement translations",
    "surveyList": "Browse polls",
    "tenantLogin": "Tenant selection",
    "toolCreate": "Create a tool",
    "toolDetails": "Tool details",
    "toolEdit": "Edit tool",
    "videoCreate": "Create a video",
    "videoDetails": "Video details",
    "videoEdit": "Edit video",
    "videoTranslations": "Video translations",
    "recipePreparationList": "Browse recipe images"
  },
  "titleConflict": {
    "explanation": "Please make sure you are not creating a duplicate {{ content }}, as there is already one existing using the same name",
    "inLanguage": "{{ content }} in language {{ language }}.",
    "severalLanguages": "{{ content }} in several languages."
  },
  "toast": {
    "translationDownload": "Translation download started"
  },
  "togglableSearchList": {
    "emptyStateLabel": "No items found",
    "itemRemovalDescription": "Are you sure you want to remove the item from the list?",
    "itemRemovalTitle": "Remove from list",
    "searchInputPlaceholder": "Search items"
  },
  "translations": {
    "aiTranslationJobCreated": "AI translation generation has been requested successfully.",
    "approveAll": {
      "dialogContent": "Are you sure you want to approve all translations?",
      "dialogTitle": "Approve all translations"
    },
    "approveValid": {
      "dialogContent": "Do you want to approve valid translations: {{ languages }}?",
      "dialogTitle": "Some translations are missing"
    },
    "changeStatus": {
      "dialogContent": "Are you sure you want to change translation status?",
      "dialogTitle": "Changing translation status"
    },
    "delete": {
      "dialogTitle": "Deleting translation"
    },
    "import": {
      "error": {
        "content": "content",
        "title": "Error while importing {{ contentType }}"
      },
      "success": "Translations imported"
    },
    "noViewPermission": "You have no permission to view translations.",
    "notAvailable": "No translations available",
    "reassignSourceLanguage": {
      "label": "Reassign source",
      "success": "Source language successfully reassigned"
    },
    "status": {
      "approved": "Approved",
      "missing": "Missing",
      "unapproved": "Unapproved"
    },
    "statusChange": {
      "toastMessage": "Translation status changed successfully."
    }
  },
  "unassignedProducts": {
    "allVariantsAlreadyAssigned": "All variants are allready assigned.",
    "assignCtns": "Assign CTNs",
    "assignToProduct": "Assign to product",
    "confirmAssign": {
      "body": "Are you sure you want to assign all CTN CTV combinations to this product?",
      "bulkBody": "Assign {{count}} CTNs and all their CTV combinations to this product?",
      "title": "Confirm assignment"
    },
    "confirmPartialAssign": {
      "body": "CTN {{ctn}} still has unassigned CTVs: {{missingCtvs}}. Add them to this device before saving?",
      "deny": "Save without them",
      "proceed": "Add missing CTVs",
      "title": "Confirm CTV assignment"
    }
  },
  "unit": {
    "hour": {
      "plural": "hours",
      "singular": "hour"
    },
    "kPa": "kPa",
    "minute": {
      "plural": "minutes",
      "singular": "minute"
    },
    "psi": "psi",
    "second": {
      "plural": "seconds"
    }
  },
  "unitSystem": {
    "imperial": "Imperial system",
    "metric": "Metric system",
    "usCustomary": "US Customary"
  },
  "unknownLanguage": "Unknown language",
  "unknownTranslationFor": {
    "ingredient": "Unknown translation for ingredient {{id}}"
  },
  "unofficial_allergen": {
    "added_sugars": "Added sugars",
    "alcohol": "Alcohol",
    "honey": "Honey",
    "meat": "Meat",
    "non_vegetarian": "Non-vegetarian",
    "pork": "Pork",
    "red_meat": "Red meat"
  },
  "user": {
    "assignedDomains": "Assigned domains",
    "assignedUserRoles": "Assigned user roles",
    "browse": {
      "title": "Browse users"
    },
    "company": {
      "label": "Company",
      "placeholder": "Enter company"
    },
    "deactivatedAt": "Deactivated at",
    "deactivationInformation": "Deactivation information",
    "details": "User details",
    "domainRelatedUserRoles": "Domain related user roles",
    "email": {
      "label": "Contact e-mail",
      "placeholder": "Enter contact e-mail"
    },
    "form": {
      "close": {
        "content": "You are about to leave this screen and discard the user information you entered. Do you want to save the user to continue editing later?",
        "title": "Save user?"
      },
      "create": "Create user",
      "domainSelection": "Domain selection",
      "edit": "Edit user",
      "placeholder": {
        "domains": "Assigned countries",
        "role": "Choose user role"
      }
    },
    "id": "User ID",
    "modifiedAt": "Last modified",
    "name": {
      "isRequired": "Name is required",
      "label": "Name",
      "placeholder": "Enter name"
    },
    "permissions": "Permissions",
    "registeredAt": "Registered at",
    "role": "Role",
    "saveSuccessful": "User has been successfully saved",
    "status": {
      "active": "Active",
      "deleted": "Deactivated",
      "inactive": "Deactivated"
    },
    "statusChangeDialog": {
      "deactivate": {
        "description": "User will be deactivated and won't be able to change or view content.",
        "title": "Are you sure you want to deactivate this user?"
      },
      "reactivate": {
        "title": "Reactivate this user?"
      }
    },
    "toastMessage": {
      "deactivated": "User deactivated",
      "reactivated": "User reactivated"
    },
    "user": "User",
    "userName": "User name",
    "userRole": "User role",
    "userRolesAndPermission": "Roles and permissions",
    "username": {
      "isRequired": "Username is required",
      "label": "Username",
      "placeholder": "Enter username"
    },
    "usernameExistsDialog": {
      "description": "An account with entered username already exists. View their user profile or change username.",
      "saveLabel": "View user",
      "title": "Username already exists"
    }
  },
  "userGuide": {
    "administrators": {
      "description": "Through this module, we can create and adjust profiles for AdminUI users. Each user (or administrator) has specific roles that can be adjusted here. These roles determine which modules (or subset of content within a module) the user sees and what actions they can perform.",
      "title": "About the administrators module"
    },
    "aiTranslations": {
      "description": "In this module, you can see the overview of all AI translation jobs, their details, and their status.\n\nThe actual jobs can be requested on the individual content's details page (through the translations sections) or in bulk through the TACA module.\n\nDepending on the number of requested translations in a given job, the time needed for it to be concluded may vary.",
      "title": "About the AI translations module"
    },
    "announcements": {
      "description": "Announcements offer a direct communication with the user through a carousel on the application. They serve to highlight actions, offers, recipes or other content, etc.",
      "title": "About the announcements module"
    },
    "articleCollections": {
      "description": "Article collections are used to group together maintenance and setup articles. They can be tied to a specific appliance category to provide the default support articles for a given group of devices. Additionally, they can also be tied to a specific device to offer all the needed information the user might need on how to correctly maintain and troubleshoot their devices.",
      "title": "About the article collections module"
    },
    "articles": {
      "description": "Articles serve as the main content to communicate information to users. They can talk about general information, or about a specific device, offer, or define information about proper maintenance of products.",
      "title": "About the articles module"
    },
    "bulkActions": {
      "description": "The bulk actions module (or TACA - Translations and content actions) offers a wide variety of actions. Here, we can manipulate different content in bulk. A prepared list of recipes, articles, recipe books, or highlights can have their status adjusted, translations manipulated, or they can be published all at once.",
      "title": "About the bulk actions module"
    },
    "campaigns": {
      "description": "Campaigns are collections of highlights tied together for a special purpose.\n\nThese highlight videos are injected into the user's feed based on the frequency that is selected in the campaign. This way, the content team can drive specific content based on the occasion and raise its visibility for the users.",
      "title": "About the campaigns module"
    },
    "comments": {
      "description": "This module focuses on the overview and management of both user-generated and HomeID-generated comments in the system. ",
      "title": "About the comments module"
    },
    "consumers": {
      "description": "Through this module, an overview of the end-users of the applications can be monitored. Additional user information, the use of their appliances and their engagement with the community are available.",
      "title": "About the consumers module"
    },
    "contentPublishing": {
      "description": "Content can be published or unpublished through this module. Each publishing profile has an array of validations that can be seen here.\n\nThis module can be entered through a specific content details screen, which will result in automatically populated information needed to enter the publishing flow.",
      "title": "About the content publishing module"
    },
    "contentScheduler": {
      "description": "Through the content scheduler, publishing and unpublishing can be scheduled in advance. Scheduling the unpublishing of content is only possible as part of the scheduled publishing process; therefore, scheduling the unpublishing of already published content is not feasible.",
      "title": "About the content scheduler module"
    },
    "countdowns": {
      "description": "Countdowns serve to inform the user about a time-sensitive event or action. \n\nDepending on their implemented details, they can be rendered either on the application landing page or on an article's details screen.",
      "title": "About the countdowns module"
    },
    "countries": {
      "description": "The countries module provides an overview of all countries where the application is available. Through it, the country configuration, country language structure, and available appliance categories can be adjusted.",
      "title": "About the countries module"
    },
    "easyRecipeBooks": {
      "description": "Easy recipe books are similar to regular recipe books, but have a specific purpose. Since the application can be daunting for new users, a special carousel was created to showcase easy recipe books to such users, which contain recipes that are the best fit to start with.",
      "title": "About the easy recipe books module"
    },
    "highlights": {
      "description": "Highlights serve as entities for DAM videos that are displayed in a feed-like fashion on the application. Each highlight can be linked to a specific piece of content to drive engagement directly to a recipe or article.",
      "title": "About the highlights module"
    },
    "ingredients": {
      "description": "In the ingredients module, an overview of user-created and HomeID-managed ingredients is present. Through this module, the ingredients can be prepared and calibrated to provide accurate nutritional calculations for the recipes.",
      "title": "About the ingredients module"
    },
    "onboardingAnnouncements": {
      "description": "Onboarding announcements are similar to regular announcements, but they have a special use case and are used as part of the “get started\" journey for new users of the application. These are shown to the new user first, and often lead to articles or recipes that can showcase the application's possibilities and offer a good place to start the journey.",
      "title": "About the onboarding announcements module"
    },
    "plans": {
      "description": "The personal message system (or PMS) serves to set up rules and milestones that the user must reach to receive a specific system message. ",
      "title": "About the personal message system module"
    },
    "productRanges": {
      "description": "Product ranges are groups of devices that have common features and technical details. Each device in a product range can create the same recipes.",
      "title": "About the product ranges module"
    },
    "productRecipeLists": {
      "description": "Product recipe lists are collections of recipes, which are tied to a specific product. They are shown directly as ideas on the user's product page.",
      "title": "About the product recipe lists"
    },
    "products": {
      "description": "The Products module (also referred to as Product Management UI) serves to provide all necessary information about the products in our system. Products consist of devices and accessories, which further break down into standalone, kits, and consumables. This module covers tools as well.\n\nThrough this module, products can be created and adjusted, activated in a specific market, and product documentation can be looked into.",
      "title": "About the products module"
    },
    "promoCodes": {
      "description": "Promo codes (also referred to as Vouchers) are entities that were introduced as part of the advent calendars feature.",
      "title": "About the promo codes module"
    },
    "recipeBookCarousels": {
      "description": "Recipe book carousels (or sometimes referred to as pack holders) are collections of specific recipes that will be displayed on a carousel on the application. Only one can be activated per country.",
      "title": "About the recipe book carousels module"
    },
    "recipeBooks": {
      "description": "Recipe books (or commonly referred to as collections or recipe collections) are collections of recipes that can be HomeID-managed or user-created. ",
      "title": "About the recipe books module"
    },
    "recipeCarouselLists": {
      "description": "Recipe carousels (also referred to as pinned holders) give a higher priority to a specific recipe book carousel, and only one can be activated in a country.",
      "title": "About the recipe carousels module"
    },
    "recipes": {
      "description": "In this module, you can have an overview of all HomeID-managed and user-created recipes. They can be created, edited, and published through this module. \n\nYou can add translations, approve them, manage comments and other user-generated interactions with the recipes.",
      "title": "About the recipes module"
    },
    "reportedContent": {
      "description": "The reported content module serves as a hub to review all types of reported content and have an overview of new reports. Through it, necessary actions can be taken to either resolve the report or remove or adjust the reported content.",
      "title": "About the reported content module"
    },
    "shopAnnouncements": {
      "description": "Shop announcements are part of the application's e-commerce features and are served in the shop tab.",
      "title": "About the shop announcements module"
    },
    "surveys": {
      "description": "Polls (or sometimes surveys) are content for engaging the user and serve to better understand their preferences. They are prepared, adjusted and surveyed in this module. The answers metrics for each poll are also visible here.",
      "title": "About the polls module"
    },
    "videos": {
      "description": "Videos (also referred to as Co-creator videos) are similar to Highlights in that they are a wrapper for DAM videos, but with the addition of subtitles. They are also served differently, as they are part of the co-creator profiles.",
      "title": "About the videos module"
    },
    "recipePreparations": {
      "description": "This module lists consumer recipe preparation images. Filter by Live and Live flagged, open image detail, or jump to linked recipe.",
      "title": "About the recipe images module"
    }
  },
  "users": {
    "searchPlaceholder": "Find user by name or email address"
  },
  "validation": {
    "generic": {
      "conditionIs": "When { property }} is {{ value }}",
      "conditionIsBetween": "When {{ property }} is between {{ first }} and {{ second }}",
      "conditionIsOver": "When {{ property }} is over {{ value }}",
      "conditionIsUnder": "When {{ property }} is under {{ value }}",
      "mustBe": "{{ property }} must be {{ value }}",
      "mustBeBetween": "{{ property }} must be between {{ first }} and {{ second }}"
    },
    "processingStep": {
      "required": "Recipe must have at least one processing step.",
      "requiredByAirfyer": "Processing steps must have temperatures and processing times specified."
    }
  },
  "validator": {
    "mustBeInteger": "Input can't be a decimal number."
  },
  "video": {
    "browse": {
      "title": "Browse videos"
    }
  },
  "videoUrl": {
    "dam": {
      "label": "DAM Video link",
      "placeholder": "Paste video link from DAM"
    },
    "errors": {
      "fileTooLarge": "Maximum video size is {{ maxSizeInMb }} MB",
      "invalidAspectRatio": "Invalid video aspect ratio. Expected {{ requiredAspectRatio }}, but video is {{ aspectRatio }}.",
      "invalidProtocol": "Link can only accept URL address that starts with \"https\".",
      "maxDuration": "Video duration is {{ duration }} seconds, which exceeds the maximum allowed duration of {{ maxDuration }} seconds.",
      "minResolution": "Video resolution too low. Minimum required is {{ minResolution }}, but video is {{ resolution }}.",
      "noVideoContent": "This link does not contain any video.",
      "notValid": "URL is not valid."
    },
    "pal": {
      "label": "PAL Video",
      "placeholder": "Paste video link from PAL"
    },
    "placeholder": "Paste video link"
  },
  "viewType": {
    "social": "Social",
    "technical": "Technical"
  },
  "vitamin": {
    "biotin": "Biotin",
    "folicAcid": "Folic Acid",
    "niacin": "Niacin",
    "pantothenicAcid": "Pantothenic acid",
    "riboflavin": "Riboflavin",
    "thiamin": "Thiamin",
    "title": "Vitamins",
    "vitaminA": "Vitamin A",
    "vitaminB12": "Vitamin B-12",
    "vitaminB6": "Vitamin B-6",
    "vitaminC": "Vitamin C",
    "vitaminD": "Vitamin D",
    "vitaminE": "Vitamin E",
    "vitaminK": "Vitamin K"
  },
  "warning": {
    "iedge": {
      "description": "It seems you are using Internet Explorer or Edge browser. Application might not behave as expected.\n\n<br><br>\n\nIf you experience any issues, please try using Google Chrome or Mozilla Firefox.",
      "title": "Internet Explorer / Edge"
    }
  }
}